// oxfmt-ignore
export default {
  'common.yes': 'Já',
  'common.no': 'Nei',
  'common.or': 'eða',
  'common.select': 'Velja',
  'common.messages.success': 'Aðgerð tókst',
  'common.errors.404': 'Hlutur fannst ekki',
  'common.errors.403': 'Þú hefur ekki réttindi til að framkvæma þessa aðgerð',
  'common.errors.400': 'Eitthvað fór úrskeiðis, vinsamlegast hafðu samband við50skills',
  'common.preview.label': 'Sýnishorn',
  'common.delete.label': 'Eyða',
  'common.forms.select.placeholder': 'Velja...',
  'common.forms.button.save': 'Vista',
  'common.forms.button.submit': 'Staðfesta',
  'common.forms.button.remove': 'Fjarlægja',
  'common.forms.button.cancel': 'Hætta við',
  'components.filefield.add': 'Bæta við',
  'components.filefield.replace': 'Uppfæra',
  'components.imageinput.add': 'Velja mynd',
  'components.imageinput.replace': 'Uppfæra mynd',
  'files.add': 'Bæta við skrá',
  'files.accepted': 'Leyfilegar skráartegundir: {0}',
  'application.addnote.error': 'Ekki tókst að bæta við athugasemd. Vinsamlegast hafðu samband við 50skills.',
  'application.addnote.success': 'Athugasemd bætt við',
  'application.changestage.error': 'Ekki tókst að færa umsókn. Vinsamlegast hafðu samband við 50skills.',
  'application.changestage.success': '{0} fært yfir í dálk {1}',
  'application.chat.update.error': 'Ekki tókst að uppfæra athugasemd. Vinsamlegast hafðu samband við 50skills.',
  'application.chat.update.success': 'Athugasemd uppfærð',
  'application.setassignedto.success': 'Umsókn {0} hefur verið úthlutað á {1}',
  'application.setassignedto.remove': 'Úthlutun umsóknar {0} hefur verið fjarlægð',
  'application.setassignedto.error': 'Ekki tókst að úthluta notanda {0} á umsókn {1}',
  'application.grantmultifollowers.error': 'Ekki tókst að bæta við réttindum. Vinsamlegast hafið samband við 50skills.',
  'application.hire.error': 'Ekki tókst að merkja umsækjanda {0} sem ráðinn. Vinsamlegast hafið samband við 50skills.',
  'application.hire.success': 'Umsækjandi {0} hefur verið merktur sem ráðinn.',
  'application.onboard.error': 'Ekki tókst að merkja umsækjanda {0} sem virkan. Vinsamlegast hafið samband við 50skills.',
  'application.onboard.success': 'Umsækjandi {0} hefur verið merktur sem virkur.',
  'application.unonboard.error': 'Ekki tókst að merkja {0} sem óvirkan. Vinsamlegast hafið samband við 50skills.',
  'application.unonboard.success': '{0} hefur verið merktur sem virkur.',
  'application.keepname.error': 'Ekki tókst að uppfæra umsækjanda. Vinsamlegast hafið samband við 50skills.',
  'application.keepname.success': 'Uppfærsla á nafni umsækjanda tókst',
  'application.matchname.error': 'Ekki tókst að uppfæra nafn umsækjanda. Vinsamlegast hafið samband við 50skills.',
  'application.matchname.success': 'Nafn umsækjanda samsvarar núna þjóðskrá.',
  'application.reject.error': 'Ekki tókst að hafna umsækjanda. Vinsamlegast hafið samband við 50skills.',
  'application.reject.success.rejection': 'Umsækjandi hefur verið merktur sem hafnað. Tölvupóstur hefur verið sendur.',
  'application.reject.success': 'Umsækjanda hafnað.',
  'application.removefollower.error': 'Ekki tókst að breyta réttindum. Vinsamlegast hafið samband við 50skills.',
  'application.removefollower.success': "Réttindi notanda {0} frá {1} hefur verið fjarlægð",
  'application.removenote.error': 'Ekki tókst að fjarlægja athugasemd. Vinsamlegast hafið samband við 50skills.',
  'application.removenote.success': 'Athugasemd fjarlægð.',
  'application.removetasklist.error': 'Ekki tókst að fjarlægja gátlista. Vinsamlegast hafið samband við 50skills.',
  'application.removetasklist.success': 'Gátlisti fjarlægður.',
  'application.resetreview.error': 'Ekki tókst að endurstilla einkunnargjöf. Vinsamlegast hafið samband við 50skills.',
  'application.resetreview.success': 'Einkunnargjöf hefur verið endurstillt.',
  'application.setreview.error': 'Ekki tókst að gefa einkunn. Vinsamlegast hafið samband við 50skills.',
  'application.setreview.success': 'Einkunn hefur verið skráð',
  'application.store.delete.error': "Ekki tókst að eyða {0}. Vinsamlegast hafið samband við 50skills.",
  'application.store.delete.success': "{0} hefur verið eytt.",
  'application.task.toggle.error.done': 'Ekki tókst að merkja {0} sem lokið',
  'application.task.toggle.error.notdone': 'Ekki tókst að merkja {0} sem ekki lokið',
  'application.task.toggle.success.done': '{0} hefur verið merkt sem lokið',
  'application.task.toggle.success.notdone': '{0} hefur verið merkt sem ekki lokið',
  'application.unreject.error': 'Ekki var hægt að fjarlægja höfnun af umsækjanda. Vinsamlegast hafið samband við 50skills.',
  'application.unreject.success': 'Höfnun hefur verið fjarlægð af umsækjanda.',
  'application.unhire.error': 'Ekki var hægt að fjarlægja ráðningu af umsækjanda. Vinsamlegast hafið samband við 50skills.',
  'application.unhire.success': 'Ráðning hefur verið fjarlægð af umsækjanda',
  'application.retract.error': 'Ekki tókst að draga umsókn bil baka. Vinsamlegast hafið samband við 50skills.',
  'application.retract.success': 'Umsókn hefur verið merkt sem afturkölluð.',
  'application.unretract.error': 'Ekki tókst að fjarlægja afturköllun af umsókn. Vinsamlegast hafið samband við 50skills.',
  'application.unretract.success': 'Umsókn hefur verið merkt sem afturkölluð',
  'application.verifyssn.error.notfound': 'Ekki tókst að finna kennitölu í þjóðskrá',
  'application.verifyssn.error': 'Ekki tókst að staðfesta kennitölu. Vinsamlegast hafið samband við 50skills.',
  'application.verifyssn.keepormatch': 'Kennitala staðfest en nafn umsækjanda passar ekki við kennitölu',
  'application.verifyssn.success': 'Nafn og kennitala hefur verið staðfest.',
  'application.verifyssn.unverified': 'Óstaðfest',
  'application.verifyssn.verified': 'Staðfest',
  'application.edit.ssn.success': 'Kennitala umsækjanda hefur verið uppfærð',
  'application.edit.ssn.error': 'Ekki tókst að uppfæra kennitölu. Vinsamlegast hafið samband við 50skills.',
  'application.edit.header': 'Breyta umsókn',
  'changepass.submit.error': 'Ekki tókst að breyta lykilorði. Staðfestir að gamla lykilorðið sé rétt og nýju lykilorðin séu eins.',
  'changepass.submit.success': 'Lykilorði hefur verið breytt. Þú þarft að skrá þig aftur inn með nýja lykilorðinu þínu.',
  'changepass.validate.pass2error': "Nýju lykilorðin eru ekki eins.",
  'career.update.image.success': 'Mynd uppfærð',
  'career.update.image.error': 'Ekki var hægt að uppfæra mynd. Vinsamlegast hafið samband við 50skills',
  'jobs.createjob': 'Nýtt starf',
  'jobs.export': 'Flytja út',
  'jobs.tabs.archived': 'Geymsla',
  'jobs.tabs.drafts': 'Drög',
  'jobs.tabs.expired': 'Útrunnið',
  'jobs.tabs.published': 'Í loftinu',
  'jobs.tabs.label': 'Staða starfa',
  'edituser.create.email.error': 'Notandinn er nú þegar til í 50skills.',
  'edituser.create.error': 'Villa kom upp við stofnun notanda.',
  'edituser.create.success': 'Notandi hefur verið stofnaður.',
  'errors.required': 'Nauðsynlegt er að fylla þennan reit út',
  'language.inSentence.en': 'ensku',
  'language.inSentence.is': 'íslensku',
  'language.inSentence.pl': 'pólsku',
  'language.inSentence.no': 'norsku',
  'language.inSentence.sv': 'sænsku',
  'language.inSentence.fr': 'frönsku',
  'general.en': 'Enska',
  'general.is': 'Íslenska',
  'general.yes': 'Já',
  'general.no': 'Nei',
  'helpers.defno': 'Sterkt nei',
  'helpers.no': 'Nei',
  'helpers.strongyes': 'Sterkt já',
  'helpers.yes': 'Já',
  'helpers.add': 'Bæta við skrá',
  'hiremodal.button.cancel': 'Hætta við',
  'hiremodal.button.submit': 'Ráða',
  'hiremodal.confirmtext': 'Viltu merkja umsækjandann sem ráðinn?',
  'hiremodal.title': 'Ráða umsækjanda',
  'retractmodal.button.cancel': 'Hætta við',
  'retractmodal.button.submit': 'Draga umsókn til baka',
  'retractmodal.confirmtext': 'Ertu viss um að þú viljir merkja umsóknina sem dregna til baka?',
  'retractmodal.title': 'Draga umsókn til baka',
  'exportmodal.title': 'Flytja út umsækjendur',
  'exportmodal.exporting.number': 'Flytja út {0} af {1} umsækjendum',
  'exportmodal.exporting.filteredout': 'Síur í notkun',
  'exportmodal.labels.exporttype': 'Tegund útflutnings',
  'exportmodal.labels.headers': 'Veldu flokka',
  'exportmodal.labels.questions': 'Veldu spurningar',
  'exportmodal.exporttype.xlsx': 'XLSX',
  'exportmodal.exporttype.csv': 'CSV',
  'exportmodal.fields.details': 'UPPLÝSINGAR',
  'exportmodal.fields.id': 'Umsóknar ID',
  'exportmodal.fields.name': 'Nafn',
  'exportmodal.fields.email': 'Netfang',
  'exportmodal.fields.phone': 'Símanúmer',
  'exportmodal.fields.ssn': 'Kennitala',
  'exportmodal.fields.age': 'Aldur',
  'exportmodal.fields.gender': 'Kyn',
  'exportmodal.fields.jobstatus': 'STAÐA STARFS',
  'exportmodal.fields.jobid': 'ID starfs',
  'exportmodal.fields.jobtitle': 'Starfstitill',
  'exportmodal.fields.jobdepartment': 'Deild starfs',
  'exportmodal.fields.joblocation': 'Staðsetning starfs',
  'exportmodal.fields.joblabel': 'Merki starfs',
  'exportmodal.fields.date': 'Dagsetning umsóknar',
  'exportmodal.fields.is_rejected': 'Er hafnað',
  'exportmodal.fields.is_notified_of_rejection': 'Höfnunartilkynning send',
  'exportmodal.fields.date_rejected': 'Dagsetning höfnunar',
  'exportmodal.fields.is_hired': 'Er ráðin/n',
  'exportmodal.fields.date_hired': 'Dagsetning ráðningar',
  'exportmodal.fields.is_retracted': 'Er umsókn dregin til baka',
  'exportmodal.fields.is_manually_added': 'Handvirkt bætt við',
  'exportmodal.fields.referred_site': 'Uppspretta',
  'exportmodal.fields.stage_name': 'Nafn dálks',
  'exportmodal.fields.num_reviews': 'Fjöldi einkunna',
  'exportmodal.fields.num_notes': 'Fjöldi umsagna',
  'exportmodal.select': 'Velja allt',
  'exportmodal.deselect': 'Afvelja allt',
  'exportmodal.button.cancel': 'Hætta við',
  'exportmodal.button.submit': 'Flytja út',
  'exportmodal.button.close': 'Loka',
  'exportmodal.submit.error': 'Villa við að flytja út gögn, vinsamlegast hafið samband við 50skills.',
  'exportmodal.submitted.title': 'Sæki gögn',
  'exportmodal.submitted.confirmtext.sent': 'Skráin er í vinnslu og verður send á þitt netfang:',
  'exportmodal.submitted.confirmtext.ready': 'þegar hún er tilbúin.',
  'exportmodal.submitted.notice': 'Athugið að þetta gæti tekið nokkrar mínútur. Ef þú finnur póstinn ekki í pósthólfinu, þá gætirðu athuga ruslpóstinn.',
  'exportjobsmodal.title': 'Flytja út störf',
  'exportjobsmodal.filter.publisheddate.from': 'Starf sett í loftið • Frá',
  'exportjobsmodal.filter.publisheddate.to': 'Starf sett í loftið • Til',
  'exportjobsmodal.filter.status.header': 'STAÐA STARFS',
  'exportjobsmodal.filter.status.published': 'Í loftinu',
  'exportjobsmodal.filter.status.expired': 'Runnið út',
  'exportjobsmodal.filter.status.drafts': 'Drög',
  'exportjobsmodal.filter.status.archived': 'Í geymslu',
  'exportjobsmodal.labels.headers': 'Dálkar',
  'exportjobsmodal.fields.details': 'UPPLÝSINGAR',
  'exportjobsmodal.fields.id': 'ID',
  'exportjobsmodal.fields.department': 'Deild',
  'exportjobsmodal.fields.labels': 'Merki',
  'exportjobsmodal.fields.title': 'Titill',
  'exportjobsmodal.fields.location': 'Staðsetning',
  'exportjobsmodal.fields.worktype': 'Tegund',
  'exportjobsmodal.fields.status': 'Staða starfs',
  'exportjobsmodal.fields.dates': 'DAGSETNINGAR',
  'exportjobsmodal.fields.datecreated': 'Stofnun',
  'exportjobsmodal.fields.datepublished': 'Sett í loftið',
  'exportjobsmodal.fields.deadline': 'Umsóknarfrestur',
  'exportjobsmodal.fields.applicantstatistics': 'UMSÓKNARTÖLFRÆÐI',
  'exportjobsmodal.fields.numapplicants': '# Umsóknir',
  'exportjobsmodal.fields.hiredapplicants': '# Ráðnir',
  'exportjobsmodal.fields.rejectedapplicants': '# Hafnaðir',
  'exportjobsmodal.fields.retractedapplications': '# Dregnar til baka',
  'exportjobsmodal.select': 'Velja allt',
  'exportjobsmodal.deselect': 'Afvelja allt',
  'exportjobsmodal.button.cancel': 'Hætta við',
  'exportjobsmodal.button.submit': 'Flytja út',
  'exportjobsmodal.button.close': 'Loka',
  'exportjobsmodal.submit.error': 'Villa við að flytja út gögn, vinsamlegast hafið samband við 50skills.',
  'exportjobsmodal.submitted.title': 'Sæki gögn',
  'exportjobsmodal.submitted.confirmtext.sent': 'Skráin er í vinnslu og verður send á þitt netfang:',
  'exportjobsmodal.submitted.confirmtext.ready': 'þegar hún er tilbúin.',
  'exportjobsmodal.submitted.notice': 'Athugið að þetta gæti tekið nokkrar mínútur og ekki gleyma að athuga ruslpóstinn ef þú sérð ekki póstinn.',
  'integration.submit.error': 'Gat ekki sent inn gögn. Vinsamlegast hafið samband við 50skills.',
  'integration.submit.error.500': 'Eitthvað fór úrskeiðis - vinsamlegast athugið að öll gögn séu rétt slegin inn',
  'integration.submit.save': 'Form vistað.',
  'integration.delete.error': 'Villa. Vinsamlegast hafið samband við 50skills..',
  'integration.preview.title': 'Sýnishorn',
  'integration.preview.error': 'Villa kom upp við forskoðun. Vinsamlegast hafið samband við 50skills.',
  'integration.validators.ssn': 'Ógild kennitala',
  'integration.validators.number': 'Inntak ætti aðeins að innihalda tölur',
  'integration.validators.decimal': 'Inntak ætti aðeins að innihalda tölur, á forminu 0.00',
  'integration.validators.bankNumber': 'Bankanúmer þarf að vera á bilinu 1-4 tölustafir',
  'integration.validators.ledger': 'Höfuðbók ætti að vera 2 tölustafir',
  'integration.validators.accountNumber': 'Reikningsnúmer þarf að vera 1-6 tölustafir',
  'job.removestage.success': 'Dálki hefur verið eytt',
  'job.removestage.error': 'Ekki tókst að eyða dálki. Vinsamlega hafðu samband við 50skills.',
  'job.addapplicant.error': 'Ekki tókst að bæta við umsækjanda. Vinsamlegast yfirfarið formið og hafið samband við 50skills.',
  'job.addapplicant.success': 'Ný umsókn stofnuð.',
  'job.archive.modal.header': 'Setja starf í geymslu',
  'job.archive.modal.text': 'Ertu viss um að þú viljir setja starfið: {0} í geymslu?',
  'job.archive.modal.button': 'Setja í geymslu',
  'job.archive.error': 'Villa kom upp við að geyma starf. Vinsamlegast hafið samband við 50skills.',
  'job.archive.success': 'Starf hefur verið sent í geymslu.',
  'job.bulkgrant.error': 'Ekki tókst að hafna völdum umsækjendum. Vinsamlegast hafið samband við 50skills.',
  'job.bulkreject.success.marked': '{0} umsækjendum hefur verið hafnað og umsókn þeirra merkt sem Tilkynnt',
  'job.bulkreject.success.notified': '{0} umsækjendum hefur verið hafnað og tilkynning send út',
  'job.bulkreject.success': '{0} umsóknum hefur verið hafnað.',
  'job.bulkhire.error': 'Ekki tókst að ráða aðilana. Vinsamlegast hafið samband við 50skills.',
  'job.bulkhire.success': '{0} aðilar ráðnir',
  'job.bulkhire.title': 'Ráða umsækjendur',
  'job.bulkhire.confirm': 'Ertu viss um að þú viljir ráða eftirfarandi aðila?',
  'job.bulkhire.noapplicants': 'Það eru engar virkar umsóknir í valinu',
  'job.bulkhire.button.close': 'Loka',
  'job.bulkhire.button.cancel': 'Hætta við',
  'job.bulkhire.button.submit': 'Staðfesta',
  'job.bulkmove.success': '{0} umsóknir færðar í dálk {1}.',
  'job.bulkmove.error': 'Ekki tókst að færa {0} umsóknir í dálk {1}.',
  'job.bulkmessage.error': 'Ekki tókst að senda skilaboð. Vinsamlegast hafið samband við 50skills.',
  'job.bulkmessage.success': '{0} skilaboð hafa verið send',
  'job.bulkmessage.title': 'Senda skilaboð',
  'job.bulkmessage.confirm.single': 'Ertu viss um að þú viljir senda skilaboð á',
  'job.bulkmessage.confirm.multi': 'Ertu viss um að þú viljir senda skilaboð á eftirfarandi aðila?',
  'job.bulkmessage.button.cancel': 'Hætta við',
  'job.bulkmessage.button.submit': 'Senda skilaboð',
  'job.bulkretract.error': 'Ekki tókst að draga til baka umsóknir. Vinsamlegast hafið samband við 50skills.',
  'job.bulkretract.success': '{0} umsóknir dregnar til baka',
  'job.bulkactive.error': 'Ekki tókst að gera umsóknir virkar. Vinsamlegast hafið samband við 50skills.',
  'job.bulkactive.success': '{0} umsóknir gerðar virkar',
  'job.bulkdelete.success': '{0} umsóknum eytt',
  'job.bulkdelete.error': 'Ekki tókst að eyða umsóknunum. Vinsamlegast hafið samband við 50skills.',
  'job.create.nolang.title': 'Ekkert tungumál valið',
  'job.create.nolang.body': 'Smelltu á + hnappinn til vinstri til að bæta við tungumáli fyrir þetta starf.',
  'job.create.error': 'Ekki tókst að stofna starf. Vinsamlegast hafið samband við 50skills.',
  'job.create.success': 'Starf vistað sem drög.',
  'job.create.field.required': 'Nauðsynlegt er að fylla þennan reit út',
  'job.drafts.error': 'Ekki tókst að færa starf. Vinsamlegast hafið samband við 50skills.',
  'job.drafts.success': 'Starf hefur verið fært yfir í drög.',
  'job.duplicate.error': 'Ekki tókst að afrita starf. Vinsamlegast hafið samband við 50skills.',
  'job.duplicate.success': 'Starf hefur verið afritað og vistað í drög.',
  'job.immediateupdate.error': 'Ekki tókst að uppfæra starfið. Vinsamlegast hafið samband við 50skills.',
  'job.immediateupdate.success': 'Starf hefur verið uppfært',
  'job.renamestage.success': 'Dálkanafn uppfært í {0}',
  'job.renamestage.error': 'Ekki tókst að breyta nafni dálks í {0}, vinsamlegast hafið samband við 50skills',
  'job.addstage.success': 'Dálki bætt við',
  'job.addstage.error': 'Ekki tókst að bæta við dálki. Vinsamlegast hafið samband við 50skills.',
  'job.nodeadline': 'Enginn umsóknarfrestur',
  'job.nolocation': 'Engin staðsetning',
  'job.nodepartment': 'Engin deild',
  'job.notitle': 'Enginn titill hefur verið settur',
  'job.datepublished': 'Birt: {0}',
  'job.nodatepublished': 'Starf ekki birt',
  'job.unknowndatepublished': 'Óþekkt birtingardagsetning',
  'job.datecreated': 'Stofnað: {0}',
  'job.nodatecreated': 'Óþekkt stofnunardagsetning',
  'job.dateexpired': 'Rann út: {0}',
  'job.nodateexpired': 'Óþekkt dagsetning',
  'job.datearchived': 'Geymt: {0}',
  'job.nodatearchived': 'Óþekkt geymsludagsetning',
  'job.datescheduledpublish': 'Verður birt: {0}',
  'job.publish.error': 'Villa við virkjun starfs. Vinsamlegast hafið samband við 50skills.',
  'job.publish.success': 'Starf hefur verið virkjað.',
  'job.statistics.all': 'Frá upphafi',
  'job.statistics.seven': 'Síðustu 7 daga',
  'job.statistics.thirty': 'Síðustu 30 daga',
  'job.statistics.today': 'Í dag',
  'job.statistics.from': 'Tímabil:',
  'job.tips.notvisible': 'Starfið er falið (sést ekki á ráðningarsíðu)',
  'job.tips.visible': 'Starfið er virkt og birt á ráðningarsíðu',
  'job.type.employee': 'Starfsmaður',
  'job.type.intern': 'Starfsnemi',
  'job.type.not_specified': 'Á ekki við',
  'job.type.seasonal': 'Árstíðabundin',
  'job.type.temporary': 'Tímabundin',
  'job.unpublish.error': 'Ekki tókst að taka starf úr birtingu. Vinsamlegast hafið samband við 50skills.',
  'job.unpublish.success': 'Starf tekið úr birtingu.',
  'job.update.description.error': "Ekki tókst að uppfæra starfslýsingu. Vinsamlegast hafið samband við 50skills.",
  'job.update.description.success': "Starf hefur verið uppfært",
  'job.update.followers.error': "Ekki tókst að uppfæra aðgang. Vinsamlegast hafið samband við 50skills.",
  'job.update.followers.success': "Aðgangur starfs hefur verið uppfærður",
  'job.update.followers.back': "Til baka",
  'job.update.followers.cancel': "Hætta við",
  'job.update.form.error': "Ekki tókst að uppfæra umsóknarform. Vinsamlegast hafið samband við 50skills.",
  'job.update.form.success': "Umsóknarform hefur verið uppfært.",
  'job.update.social.error': "Ekki tókst að uppfæra samfélagsmiðla stillingar. Vinsamlegast hafið samband við 50skills.",
  'job.update.rewards.error': "Ekki tókst að uppfæra verðlauna stillingar. Vinsamlegast hafið samband við 50skills.",
  'job.update.rewards.success': "Verðlaun og samfélagsmiðla stillingar hafa verið uppfærð.",
  'job.options.archive': 'Setja í geymslu',
  'job.options.drafts': 'Færa í drög',
  'job.options.duplicate': 'Afrita',
  'job.options.edit': 'Breyta',
  'job.options.addstage': 'Nýr dálkur',
  'job.options.publish': 'Setja í birtingu',
  'job.options.share': 'Deila',
  'job.options.unpublish': 'Taka úr birtingu',
  'job.options.delete': 'Eyða',
  'job.options.delete.confirmation': 'starfi og öllum umsóknum sem það hefur að geyma',
  'job.options.export': 'Flytja út',
  'job.store.delete.error': "Ekki tókst að eyða {0}. Vinsamlegast hafið samband við 50skills.",
  'job.store.delete.success': "Starfi eytt.",
  'jobsettings.tab.applicants': 'Umsækjendur',
  'jobsettings.tab.integrations': 'Samþættingar',
  'jobsettings.tab.statistics': 'Tölfræði',
  'jobsettings.tab.team': 'Notendur',
  'navigation.back': 'Til baka',
  'navigation.careersite': 'Ráðningarsíða',
  'navigation.jobs': 'Störf',
  'navigation.applicants': 'Umsækjendur',
  'navigation.messages': 'Skilaboð',
  'navigation.onboarding': 'Onboarding',
  'navigation.sharing': 'Deila',
  'navigation.supportchat': 'Aðstoð',
  'navigation.expand': 'Festa hlið',
  'navigation.collapse': 'Losa hlið',
  'navigation.companies': 'Fyrirtæki',
  'navigation.apps': 'Apps',
  'navigation.settings.headers.admin': 'Admin stillingar',
  'navigation.settings.headers.career': 'Ráðningarsíða',
  'navigation.settings.company': 'Fyrirtæki',
  'navigation.settings.departments': 'Deildir',
  'navigation.settings.labels': 'Merki',
  'navigation.settings.locations': 'Staðsetningar',
  'navigation.settings.templates': 'Sniðmát',
  'navigation.settings.careertheme': 'Þema',
  'navigation.settings.career': 'Ráðningarsíða',
  'navigation.settings.team': 'Notendur',
  'navigation.settings.jobboards': 'Starfatorg',
  'navigation.settings.joborder': 'Starfaröðun',
  'navigation.settings.integrations': 'Tengingar',
  'navigation.settings.worktypes': 'Tegund starfs',
  'navigation.profile.headers.profile': 'Prófíll',
  'navigation.profile.profile': 'Prófíll',
  'navigation.profile.notifications': 'Tilkynningar',
  'navigation.profile.security': 'Öryggi',
  'navigation.profile.api': 'API',
  'templates.store.newtasklist.name': 'Nýr aðgerðarlisti',
  'templates.store.removetasklist.error': 'Ekki tókst að fjarlægja sniðmát. Vinsamlegast hafið samband við 50skills.',
  'templates.store.removetasklist.success': 'Sniðmát fyrir aðgerðarlista hefur verið fjarlægt',
  'user.grant.error': 'Ekki tókst að gefa notanda aðgang að umsókn. Vinsamlegast hafið samband við 50skills.',
  'user.grant.success': 'Aðgangi hefur verið veitt.',
  'user.inactive': 'óvirk',
  'user.revoke.error': "Ekki tókst að fjarlægja réttindi. Vinsamlegast hafið samband við 50skills.",
  'user.revoke.success': "Access revoked successfully",
  'user.role.superadmin': 'Ofur-notandi',
  'user.role.admin': 'Stjórnandi',
  'user.role.limited': 'Takmarkaður notandi',
  'user.role.recruiter': 'Ráðningarstjóri',
  'user.role.user': 'Almennur starfsmaður',
  'user.profile.invite.resend': 'Endursenda boð',
  'user.profile.role.label': 'Hlutverk',
  'user.profile.departments.label': 'Deild/ir',
  'user.profile.departments.none': 'Engar deildir',
  'user.profile.departments.fullaccess': 'Fullur aðgangur',
  'user.profile.departments.add': 'Bæta við deild',
  'user.profile.departments.edit': 'Breyta aðgangi',
  'user.profile.departments.remove': 'Fjarlægja úr deild',
  'usermenu.careerpage': 'Ráðningarsíða',
  'usermenu.notifications': 'Tilkynningastillingar',
  'usermenu.statusPage': 'Stöðusíða',
  'usermenu.company.settings': 'Stillingar',
  'usermenu.jobboards': 'Starfatorg',
  'usermenu.help': 'Hjálp / leiðbeiningar',
  'usermenu.profile': 'Prófíll',
  'usermenu.logout': 'Útskráning',
  'userstore.delete.error': 'Ekki tókst að eyða notanda. Vinsamlegast hafið samband við 50skills.',
  'userstore.delete.success': 'Notanda eytt.',
  'job.header.applicants': 'Umsækjendur',
  'job.header.today': 'Í dag',
  'job.followermenu.title': 'Ráðningarteymi',
  'application.onboardmodal.title': 'Innleiða umsækjanda',
  'application.onboardmodal.text': 'Viltu hefja innleiðingu nýs starfsmanns núna?',
  'application.onboardmodal.button.later': 'Seinna',
  'application.onboardmodal.button.go': 'Fara á onboarding svæði',
  'rejectmodal.types.reject': 'Hafna',
  'rejectmodal.types.rejecthelp': 'Merkja starfsmann sem hafnað. Engin tilkynning er send á umsækjanda.',
  'rejectmodal.types.rejectsend': 'Hafna og senda tilkynningarpóst.',
  'rejectmodal.types.rejectsendhelp': 'Senda höfnunarpóst til valinna umsækjenda.',
  'rejectmodal.types.rejectmark': 'Merkja sem hafnað og tilkynnt',
  'rejectmodal.types.rejectmarkhelp': 'Merkja starfsmann sem hafnað og tilkynnt. Engin tilkynning er send á umsækjanda.',
  'rejectmodal.title': 'Hafna umsækjendum.',
  'rejectmodal.confirm.single': 'Ertu viss um að þú viljir hafna',
  'rejectmodal.confirm.multi': 'Ertu viss um að þú viljir hafna eftirfarandi umsækjendum?',
  'rejectmodal.confirmed.reject': 'Eftirfarandi umsækjendur verða merktir sem hafnaðir:',
  'rejectmodal.confirmed.rejectsend': 'Eftirfarandi umsækjendur fá höfnunarpóst:',
  'rejectmodal.confirmed.rejectmark': 'Eftirfarandi umsækjendum verður hafnað og merktir sem "Tilkynnt":',
  'rejectmodal.excluded': 'Eftirfarandi umsækjendur verða ekki með í þessari aðgerð:',
  'rejectmodal.already.notified': '(þegar hafnað og tilkynnt)',
  'rejectmodal.already.rejected': '(þegar hafnað)',
  'rejectmodal.method.title': 'Höfnunarleið',
  'rejectmodal.method.drop.title': 'Veldu höfnunarleið',
  'rejectmodal.button.cancel': 'Hætta við',
  'rejectmodal.button.submit': 'Hafna',
  'assignmodal.button.cancel': 'Hætta við',
  'assignmodal.button.submit': 'Úthluta',
  'assignmodal.header': 'Úthluta umsækjanda',
  'assignmodal.description': 'Úthluta umsækjanda á notanda',
  'assignmodal.select.emptystate': 'Veldu notanda',
  'assignmodal.select.label': 'Notandi',
  'rejectform.label.from': 'Frá',
  'rejectform.label.message': 'Skilaboð',
  'rejectform.label.templateselect': 'Nafn sniðmáts',
  'rejectform.template.drop.title': 'Veldu sniðmát',
  'rejectform.error.message': 'Vinsamlegast bættu við meginmálstexta í tölvupóstinn.',
  'editor.placeholder.title': 'Staðsetningartexti',
  'editor.placeholder.name': 'Nafn umsækjanda',
  'editor.placeholder.job_title':'Starfstitill',
  'editor.placeholder.sender_name': 'Nafn sendanda',
  'editor.placeholder.first_name': 'Fornafn umsækjanda',
  'editor.placeholder.last_name': 'Eftirnafn umsækjanda',
  'editor.placeholder.ob_url': 'Slóð á onboarding svæði',
  'editor.placeholder.company_name': 'Nafn fyrirtækis',
  'sharejob.header': 'Deila starfi',
  'sharejob.copy.header.direct': 'Beinn hlekkur',
  'sharejob.copy.header.referral': 'Tilvísunarhlekkur',
  'sharejob.selected.tab.direct': 'Beinn hlekkur',
  'sharejob.selected.tab.referral': 'Tilvísunarhlekkur',
  'sharejob.tabs.label': 'Beinn hlekkur eða tilvísun',
  'copy.button.text': 'Afrita',
  'copy.button.copied': 'Afritun tókst',
  'sharejob.maintext': 'Þetta er varanlegur hlekkur sem vísar til 50skills auglýsingar þinnar. Hlekkurinn breytist ekki þegar þú breytir heiti atvinnuauglýsingarinnar. Þetta er ráðlögð leið til að deila starfinu þínu.',
  'sharejob.share.media': 'Deila á',
  'sharejob.share.media.with': 'Deila með',
  'sharejob.share.facebook': 'Facebook',
  'sharejob.share.linkedin': 'Linkedin',
  'sharejob.share.email': 'tölvupósti',
  'sharejob.rewards.header': 'Verðlaun fyrir ráðinn umsækjanda',
  'sharejob.modal.header': 'Deila starfi',
  'sharejob.modal.close': 'Loka',
  'userlist.header.name': 'Nafn',
  'userlist.header.email': 'Netfang',
  'userlist.header.role': 'Hlutverk',
  'userlist.header.department': 'Deild',
  'userlist.header.access': 'Aðgangur',
  'userlist.header.status': 'Staða',
  'userlist.header.options': 'Val',
  'application.options.email': 'Senda tölvupóst',
  'application.options.access': 'Veita aðgang',
  'application.options.move': 'Færa í annað starf',
  'application.options.copy': 'Afrita í annað starf',
  'application.options.edit': 'Breyta',
  'application.options.delete': 'Eyða',
  'application.options.reject': 'Hafna',
  'application.options.unreject': 'Af-hafna',
  'application.options.hire': 'Ráða',
  'application.options.unhire': 'Af-ráða',
  'application.options.retract': 'Umsókn dregin til baka',
  'application.options.unretract': 'Endurvirkja umsókn',
  'application.options.onboard': 'Onboarding',
  'application.edit.error': 'Tókst ekki að breyta. Skoðið villur í forminu eða hafið samband við 50skills.',
  'application.edit.success': 'Umsókn breytt.',
  'application.tip.assign': 'Úthluta á notanda',
  'modals.confirm.title': 'Staðfesta',
  'modals.confirm.warning': 'Þessa aðgerð er ekki hægt að afturkalla',
  'modals.confirm.please': 'Vinsamlega staðfestið',
  'modals.confirm.understanding': 'Ég samþykki',
  'modals.confirm.button.close': 'Loka',
  'modals.confirm.button.cancel': 'Hætta við',
  'modals.confirm.button.submit': 'Staðfesta',
  'modals.removeconfirm.title': 'Staðfesta eyðingu',
  'modals.removeconfirm.attachment.confirm': 'Ertu viss um að þú viljir eyða þessu viðhengi?',
  'modals.removeconfirm.note.confirm': 'Ertu viss um að þú viljir eyða þessari umsögn?',
  'modals.removeconfirm.tasklist.confirm': 'Ertu viss um að þú viljir eyða þessum aðgerðarlista?',
  'modals.removeconfirm.user.confirm': 'Ertu viss um að þú viljir eyða þessum notanda?',
  'modals.removeconfirm.contract.header': 'Eyða samningi',
  'modals.removeconfirm.contract.main': 'Ertu viss um að þú viljir eyða þessum samningi?',
  'modals.removeconfirm.contract.button': 'Eyða samningi',
  'modals.removeconfirm.warning': 'Athugið, þessi aðgerð er óafturkræf!',
  'modals.removeconfirm.button.cancel': 'Hætta við',
  'modals.removeconfirm.button.submit': 'Eyða',
  'modals.removeauthenticator.header': 'Fjarlægja auðkenningu',
  'modals.removeauthenticator.subheader': 'Öryggis vegna, sláðu inn lykilorðið þitt',
  'modals.removeauthenticator.label.password': 'Lykilorð',
  'modals.removeauthenticator.button.cancel': 'Hætta við',
  'modals.removeauthenticator.button.submit': 'Fjarlægja ',
  'modals.addauthenticator.header': 'Bæta við tveggja þátta auðkenningar appi',
  'modals.addauthenticator.subheader': 'Öryggis vegna, sláðu inn lykilorðið þitt',
  'modals.addauthenticator.password.label': 'Lykilorð',
  'modals.addauthenticator.password.error': 'Rangt lykilorð',
  'modals.addauthenticator.qrcode.helptext': '1. Skannaðu QR kóðann',
  'modals.addauthenticator.code.helptext': '2. Sláðu inn 6-stafa kóðann hér fyrir neðan',
  'modals.addauthenticator.code.label': 'Kóði',
  'modals.addauthenticator.code.required': 'Nauðsynlegt er að fylla út þennan reit',
  'modals.addauthenticator.code.error': 'Kóði passar ekki',
  'modals.addauthenticator.header.success': 'Tveggja þátta auðkenning virk',
  'modals.addauthenticator.subheader.success': 'Til hamingju, þú hefur virkjað tveggja þátta auðkenningu. Héðan í frá þegar þú skráir þig inn í 50skills munt þú þurfa að slá inn lykilorðið þitt ásamt auðkenningarkóða úr símanum.',
  'modals.addauthenticator.button.cancel': 'Hætta við',
  'modals.addauthenticator.button.submit': 'Áfram',
  'modals.addsmsauthenticator.header': 'Bæta við tveggja þátta auðkenningu í gegnum SMS',
  'modals.addsmsauthenticator.subheader': 'Öryggis vegna, sláðu inn lykilorðið þitt',
  'modals.addsmsauthenticator.password.label': 'Lykilorð',
  'modals.addsmsauthenticator.password.error': 'Rangt lykilorð',
  'modals.addsmsauthenticator.step2.helptext': '50skills mun senda kóða í símann þinn þegar þú skráir þig inn.',
  'modals.addsmsauthenticator.countrycode.label': 'Kóði lands',
  'modals.addsmsauthenticator.phonenumber.label': 'Símanúmer',
  'modals.addsmsauthenticator.phonenumber.required': 'Nauðsynlegt er að fylla út þennan reit',
  'modals.addsmsauthenticator.phonenumber.error': 'Ekki tókst að senda SMS, er númerið pottþétt rétt?',
  'modals.addsmsauthenticator.step3.helptext': 'Við sendum 6-stafa kóða í sms skeyti í símanúmerið {0}',
  'modals.addsmsauthenticator.label.code': 'Kóði',
  'modals.addsmsauthenticator.header.success': 'Tveggja þátta auðkenning virk',
  'modals.addsmsauthenticator.subheader.success': 'Til hamingju, þú hefur virkjað tveggja þátta auðkenningu. Héðan í frá þegar þú skráir þig inn í 50skills munt þú þurfa að slá inn lykilorðið þitt ásamt auðkenningarkóða úr símanum.',
  'modals.addsmsauthenticator.button.cancel': 'Hætta við',
  'modals.addsmsauthenticator.button.back': 'Til baka',
  'modals.addsmsauthenticator.button.submit': 'Áfram',
  'modals.notifytwofactor.header': 'Virkja 2FA',
  'modals.notifytwofactor.text': 'Vinsamlegast athugið, tveggja þátta auðkenning er virkjuð fyrir fyrirtækið þitt, þú munt þurfa auðkenningarforrit eins og Google Authenticator. Þú getur virkjað það á þessari síðu.',
  'modals.notifytwofactor.button.close': 'Loka',
  'modals.sendinvite.header': 'Senda boð',
  'modals.sendinvite.main': 'Ertu viss um að þú viljir senda boð á {0}? Þau munu fá tölvupóst sem veitir þeim aðgang að 50skills.',
  'modals.sendinvite.button': 'Senda boð',
  'modals.deleteuserapp.header': 'Fjarlægja API lykil',
  'modals.deleteuserapp.content': 'Ertu viss um að þú viljir fjarlægja þennan API lykil? Allir sem nota þennan lykil munu ekki geta gert það héðan í frá.',
  'modals.deleteuserapp.undone': 'Þetta er ekki hægt að afturkalla',
  'modals.adddepartment.header': 'Bæta við deild',
  'modals.adddepartment.label': 'Nafn deildar • {0}',
  'modals.adddepartment.helptext': 'Birt á starfasíðu',
  'modals.adddepartment.externalid.label': 'Utanaðkomandi ID',
  'modals.adddepartment.externalid.helptext': 'Valkvæmt utanaðkomandi ID',
  'modals.adddepartment.cancel': 'Hætta við',
  'modals.adddepartment.save': 'Vista',
  'modals.adddepartment.success': 'Deild bætt við',
  'modals.editdepartment.header': 'Breyta deild',
  'modals.editdepartment.success': 'Deild vistuð',
  'modals.deletedepartment.header': 'Eyða deild',
  'modals.deletedepartment.content': 'Ertu viss um að þú viljir eyða þessari deild? Aðgerðin er óafturkræf og allar tengingar við notendur verða einnig eyddar.',
  'modals.deletedepartment.cancel': 'Hætta við',
  'modals.deletedepartment.save': 'Eyða',
  'modals.deletedepartment.success': 'Deild eytt',
  'modals.adddepartmentuser.header': 'Bæta á deild',
  'modals.adddepartmentuser.subheader': 'Bæta notanda á deild',
  'modals.adddepartmentuser.department.label': 'Deild',
  'modals.adddepartmentuser.department.nooptions': 'Engar deildir eftir',
  'modals.adddepartmentuser.users.label': 'Notendur',
  'modals.adddepartmentuser.user.nooptions': 'Engir notendur eftir',
  'modals.adddepartmentuser.fullaccess.label': 'Fullur aðgangur',
  'modals.adddepartmentuser.fullaccess.tooltip': 'Aðgangur að öllum störfum og umsóknum fyrir valda deild',
  'modals.adddepartmentuser.fullaccess.description': 'Vinsamlegast athugaðu, aðeins ofurstjórnendur eða stjórnendur með fullan deildaraðgang geta veitt eða fjarlægt fullan deildaraðgang',
  'modals.adddepartmentuser.fullaccess.yousure': 'Ertu viss um að þú viljir veita þessum notanda fulla deildaraðgang? Hann verður með fullan aðgang að öllum störfum og umsóknum í valdri deild',
  'modals.adddepartmentusers.fullaccess.yousure': 'Ertu viss um að þú viljir veita þessum notendum fulla deildaraðgang? Þeir verða með fullan aðgang að öllum störfum og umsóknum í valdri deild',
  'modals.adddepartmentuser.cancel': 'Hætta við',
  'modals.adddepartmentuser.save': 'Bæta á deild',
  'modals.adddepartmentuser.success': 'Notanda bætt á deild',
  'modals.editdepartmentuser.header': 'Breyta deildar aðgangi',
  'modals.editdepartmentuser.save': 'Vista',
  'modals.editdepartmentuser.success': 'Deildar aðgangur vistaður',
  'modals.deletedepartmentuser.header': 'Vinsamlega staðfestu',
  'modals.deletedepartmentuser.areyousure.1': 'Ertu viss um að þú viljir fjarlægja',
  'modals.deletedepartmentuser.areyousure.2': 'úr deildinni',
  'modals.deletedepartmentuser.fullaccessdescription': 'Ef þau hafa deildaraðgang munu þau missa aðgang að öllum störfum og umsækjendum innan deildarinnar',
  'modals.deletedepartmentuser.cancel': 'Hætta við',
  'modals.deletedepartmentuser.save': 'Staðfesta og fjarlægja',
  'modals.deletedepartmentuser.success': 'Notandi fjarlægður úr deild',
  'modals.deleteuserapp.cancel': 'Hætta við',
  'modals.deleteuserapp.save': 'Fjarlæga',
  'modals.deleteuserapp.success': 'Appi eytt',
  'modals.adduserapp.header': 'Bættu við appi',
  'modals.adduserapp.label': 'App nafn',
  'modals.adduserapp.helptext': 'Skrifaðu einstakt nafn fyrir þetta App. Það er aðeins notað svo þú getir greint á milli Appa',
  'modals.adduserapp.cancel': 'Hætta við',
  'modals.adduserapp.save': 'Vista',
  'modals.adduserapp.success': 'App stofnað',
  'modals.userappcredentials.header': 'App auðkenni',
  'modals.userappcredentials.helptext': 'Afritaðu þessar upplýsingar á öruggan stað, því þær munu ekki birtast aftur og þú þarf þær til að auðkenna þig við external API hjá 50skills',
  'modals.userappcredentials.clientid.label': 'Client ID',
  'modals.userappcredentials.secret.helptext': 'Client secret er aðeins sýnt einu sinni',
  'modals.userappcredentials.clientsecret.label': 'Client Secret',
  'modals.userappcredentials.close': 'Loka',
  'modals.addlocation.header': 'Bæta við staðsetningu',
  'modals.addlocation.success': 'Staðsetningu bætt við',
  'modals.editlocation.header': 'Breyta staðsetningu',
  'modals.editlocation.success': 'Staðsetningu breytt',
  'modals.location.label': 'Nafn staðsetningar • {0}',
  'modals.location.helptext': 'Birt á starfasíðu',
  'modals.location.externalid.label': 'Utanaðkomandi ID',
  'modals.location.externalid.helptext': 'Valkvæmt utanaðkomandi ID',
  'modals.location.address.label': 'Heimilisfang',
  'modals.location.address.placeholder': 'Heimilisfang',
  'modals.location.address.initialtext': 'Sláðu inn heimilisfang',
  'modals.location.address.nomatchingtext': 'Ekkert heimilisfang fannst',
  'modals.location.isactive.label': 'Virkur',
  'modals.deletelocation.header': 'Eyða staðsetningu',
  'modals.deletelocation.text': 'Ertu viss um að þú viljir eyða þessari staðsetningu?',
  'modals.deletelocation.save': 'Eyða staðsetningu',
  'modals.deletelocation.success': 'Staðsetningu eytt',
  'job.create.crumb.new': 'Ný starfsauglýsing',
  'job.create.crumb.editing': 'Breyta starfsauglýsingu',
  'job.create.step.1': 'Starfslýsing',
  'job.create.step.1.mobile': '1',
  'job.create.step.2': 'Umsóknarform',
  'job.create.step.2.mobile': '2',
  'job.create.step.3': 'Samfélagsmiðlar & Verðlaun',
  'job.create.step.3.mobile': '3',
  'job.create.step.4': 'Aðgangur',
  'job.create.step.4.mobile': '4',
  'job.create.step.5': 'Forskoðun og birting',
  'job.create.step.5.live': 'Forskoðun',
  'job.create.step.5.mobile': '5',
  'job.create.form.header': 'Umsóknarform',
  'job.create.form.show': 'Sýna',
  'job.create.form.required': 'Nauðsynlegt',
  'job.create.form.social.header': 'Samfélagsmiðlar',
  'job.create.form.questions.header': 'Spurningar',
  'job.create.form.button.addquestion': 'Bæta við spurningu',
  'job.create.form.label.coverletter': 'Kynningarbréf',
  'job.create.form.label.cv': 'Ferilskrá',
  'job.create.form.label.name': 'Nafn',
  'job.create.form.label.email': 'Netfang',
  'job.create.form.label.phone': 'Símanúmer',
  'job.create.form.label.ssn': 'Kennitala',
  'job.create.form.label.language': 'Tungumál umsóknar',
  'job.create.form.questions.type.short': 'Stutt svar',
  'job.create.form.questions.type.para': 'Langt svar',
  'job.create.form.questions.type.single': 'Fellilisti - eitt val',
  'job.create.form.questions.type.multi': 'Fellilisti - fjölval',
  'job.create.form.questions.type.attachment': 'Viðhengi (skrá)',
  'job.create.form.questions.title.edit': 'Breyta spurningu',
  'job.create.form.questions.title': 'Bæta við spurningu',
  'job.create.form.questions.type.label': 'Tegund spurningu',
  'job.create.form.questions.qlabel': 'Spurning',
  'job.create.form.questions.qerror': 'Hvað viltu vita?',
  'job.create.form.questions.qopts': 'Valmöguleikar',
  'job.create.form.questions.multipleattachments.label': 'Leyfa mörg viðhengi',
  'job.create.form.questions.multipleattachments.yes': 'Já',
  'job.create.form.questions.multipleattachments.no': 'Nei',
  'job.create.form.questions.button.cancel': 'Hætta við',
  'job.create.form.questions.button.submit': 'Bæta við spurningu',
  'job.create.form.questions.button.submitedit': 'Uppfæra spurningu',
  'job.create.form.questions.option.edit': 'Breyta',
  'job.create.form.questions.option.moveup': 'Færa upp',
  'job.create.form.questions.option.movedn': 'Færa niður',
  'job.create.form.questions.option.delete': 'Eyða',
  'job.create.form.questions.seeoptions': 'Smelltu til að sjá valmöguleika',
  'job.create.form.questions.error': 'Spurningin inniheldur villur.',
  'job.create.form.options.tip.remove': 'Fjærlægja valmöguleika',
  'job.create.form.options.tip.add': 'Bæta við valmöguleika fyrir neðan',
  'job.create.form.options.empty': 'Valmöguleiki á ekki að vera tómur',
  'job.create.form.require': 'Nauðsynlegt',
  'job.create.form.optional': 'Valkvætt',
  'job.create.form.off': 'Óvirkt',
  'job.create.header': 'Búa til starfsauglýsingu',
  'job.create.header.edit': 'Breyta starfsauglýsingu',
  'job.create.description.header': 'Starfslýsing',
  'job.create.description.hyper.link.save': 'Vista',
  'job.create.description.hyper.link.addLink': 'Hengja hlekk',
  'job.create.description.hyper.link.linkToolTip': 'Veldu textann sem þú vilt breyta í hlekk',
  'job.create.description.hyper.link.label': 'Hlekkur',
  'job.create.button.cancel': 'Hætta við',
  'job.create.button.save': 'Vista',
  'job.create.button.back': 'Fara til baka',
  'job.create.button.savedraft': 'Vista sem drög',
  'job.create.button.cont': 'Halda áfram',
  'job.create.button.savecont': 'Vista og halda áfram',
  'job.create.label.title': 'Starfstitill',
  'job.create.label.location': 'Staðsetning',
  'job.create.label.location.add': 'Bæta við staðsetningu',
  'job.create.label.location.add.permission': 'Hafðu samband við ofurnotanda til að bæta við staðsetningu',
  'job.create.label.location.missingtranslation': 'Vantar staðsetningar þýðingu',
  'job.create.label.type': 'Tegund starfs',
  'job.create.label.status': 'Staða starfs',
  'job.create.label.deadline': 'Umsóknarfrestur (valkvætt)',
  'job.create.label.short': 'Stutt lýsing',
  'job.create.label.shortinfo': 'Birtist á starfayfirlitssíðu\n{0} stafir hámark',
  'job.create.label.visibility': 'Sýnileiki starfs',
  'job.create.label.department': 'Deild',
  'job.create.label.department.title': 'Veldu deild',
  'job.create.label.department.missingtranslation': 'Vantar þýðingu á deild',
  'job.create.short.error': 'Nauðsynlegt er að fylla út stutta lýsingu',
  'job.create.save.language.error': 'Ekki tókst að vista starfsauglýsingu. Þetta er starf er í birtingu og kveikt er á {0} og inniheldur villu. Vinsamlegast lagfærið villu eða afvirkið tungumál.',
  'job.create.location.error': 'Nauðsynlegt er að fylla staðsetningu',
  'job.create.title.error': 'Nauðsynlegt er að fylla inn starfstitil',
  'job.create.label.long': 'Um starfið',
  'job.create.preview.button.close': 'Loka',
  'job.create.preview.button.edit': 'Breyta starfsauglýsingu',
  'job.create.preview.button.publish': 'Birta starfsauglýsingu',
  'job.create.preview.text': 'forskoðun',
  'job.create.preview.openings': 'störf í boði',
  'job.create.preview.apply': 'sækja um starf',
  'job.create.linkedField.tip': 'Hlekkur milli tungumála',
  'job.create.publish.language.error': 'Ekki tókst að birta starfsauglýsingu. Tungumál {0} er virkt en þýðing hefur ekki verið kláruð.',
  'job.create.publish.no_enabled_language': 'Ekki tókst að birta starfsauglýsingu. Engin virk tungumál eru sett á starfsauglýsinguna.',

  'job.create.languages.missing.title': 'Titill',
  'job.create.languages.missing.description': 'Starfslýsing',
  'job.create.languages.missing.short': 'Stutt lýsing',
  'job.create.languages.missing.location': 'Staðsetning',
  'job.create.languages.missing.form': 'Spurningaform',
  'job.create.languages.header': 'Tungumál',
  'job.create.languages.add': 'Bæta við tungumáli',
  'job.create.languages.formIncomplete': 'Form óklárað',
  'job.create.languages.descIncomplete': 'Lýsing ókláruð',
  'job.create.languages.menu.publish': 'Virkja tungumál',
  'job.create.languages.menu.unpublish': 'Afvirkja tungumál',
  'job.create.languages.menu.delete': 'Fjarlægja tungumál',
  'job.create.languages.publish.incomplete': 'Ekki var hægt að virkja {0} þar sem tungumálagögn eru óútfyllt. Vinsamlegast bættu við gögnum þar sem vantar og reyndu að virkja aftur. Óklárað: {1}',
  'job.create.languages.publish.error': 'Ekki tókst að virkja starf. Vinsamlegast hafið samband við 50skills.',
  'job.create.languages.publish.success': 'Starf hefur verið virkjað.',
  'job.create.languages.unpublish.onlyone': 'Ekki tókst að afvirkja starf. Starfið er í birtingu og er bara með eitt tungumál á sér.',
  'job.create.languages.unpublish.error': 'Ekki tókst að afvirkja starf. Vinsamlegast hafið samband við 50skills.',
  'job.create.languages.unpublish.success': 'Starf hefur verið afvirkjað.',
  'job.create.languages.delete.error': 'Ekki tókst að fjarlægja tungumál.',
  'job.create.languages.delete.success': 'Tungumál fjarlægt.',
  'job.create.missing.question': 'Enginn spurningartexti hefur verið settur',
  'job.create.languages.enabled': 'Þetta tungumál er virkt en ekki í birtingu',
  'job.create.languages.enabled.live': 'Þetta tungumál er virkt og í birtingu',
  'job.create.languages.disabled': 'Þetta tungumál er óvirkt',

  'job.types.employee': 'Starfsmaður',
  'job.types.temporary': 'Tímabundið / Samningur',
  'job.types.intern': 'Starfsnemi',
  'job.types.seasonal': 'Árstíðabundin',
  'job.types.not_specified': 'Á ekki við',
  'job.status.full_time': 'Full vinna',
  'job.status.part_time': 'Hlutastarf',
  'job.status.per_diem': 'Dagpeningur',
  'job.status.not_specified': 'Á ekki við',
  'job.visibility.public': 'Sýna á ráðningarsíðu',
  'job.visibility.private': 'Ekki sýna starf á ráðningasíðu. Bara hægt að sækja um starf í gegnum beinan hlekk.',

  'job.create.publish.modal.title': 'Starfið er komið í loftið',
  'job.create.publish.modal.jobboard.tagline': 'Vektu athygli á starfsauglýsingunni með því að birta það beint á starfatorgum úr kerfinu',
  'job.create.publish.modal.jobboard.button': 'Starfatorg',
  'job.create.publish.modal.tagline': 'Deildu því núna með heiminum!',
  'job.create.publish.modal.publishjob.title': 'Birta á starfatorgum',
  'job.create.publish.modal.direct.title': 'Beinn hlekkur (fyrir starfatorg osfrv.)',
  'job.create.publish.modal.direct.title.single': 'Beinn hlekkur',
  'job.create.publish.modal.en': 'Ensk starfslýsing',
  'job.create.publish.modal.is': 'Íslensk starfslýsing',
  'job.create.publish.modal.direct.head': 'Beinn hlekkur',
  'job.create.publish.modal.direct.sub': 'fyrir starfatorg osfrv.',
  'job.create.publish.modal.refer.title': 'Tilvísun',
  'job.create.publish.modal.refer.head': 'Sérstakur tilvísunartengill',
  'job.create.publish.modal.button.close': 'Loka',
  'job.create.social.title': 'Samfélagsmiðla deilingar',
  'job.create.social.p1': ' Þegar þessari auglýsingu er deilt á samfélagsmiðlum er sjálfgefna myndin fyrir fyrirtækið notuð. Bættu við mynd hér ef þú vilt nota sérsniðna mynd fyrir þetta starfi.',
  'job.create.social.p2': 'Bestu niðurstöður fást með láréttri mynd: 1200 x 630 pixla. Við munum minnka breiddina niður í 1200 ef myndin er breiðari en það.',
  'job.create.social.add': 'Nýja mynd',
  'job.create.social.label.title': 'Titill á samfélagsmiðlum',
  'job.create.social.label.description': 'Lýsing á samfélagsmiðlum',
  'job.create.rewards.title': 'Verðlaun',
  'job.create.rewards.tagline': 'Veldu verðlaun fyrir ykkar starfsmenn ef að þeirra deiling leiðir til ráðningar.',
  'job.create.rewards.toggle': 'Verðlaun fyrir ráðningu',
  'job.create.rewards.label.title': 'Titill',
  'job.create.rewards.label.reward': 'Upphæð eða verðlaun',
  'job.create.access.team.header': 'Teymi',
  'job.create.access.team.search.placeholder': 'Leita að nafni eða netfangi',
  'job.create.access.team.search.enterprise.placeholder': 'Leita að nafni, netfangi eða deild',
  'job.create.access.team.add.hiringteam.tooltip': 'Bæta við ráðningarteymi',
  'job.create.access.team.add.limitedaccess.tooltip': 'Bæta við takmarkaðan aðgang',
  'job.create.access.team.search.empty': 'Enginn notandi fannst.',
  'job.create.access.team.empty': 'Allir notendur í teymi.',
  'job.create.access.hiringteam.header': 'Ráðningarteymi',
  'job.create.access.hiringteam.header.tooltip': 'Fullur aðgangur að þessu starfi og öllum umsóknum',
  'job.create.access.hiringteam.remove.tooltip': 'Fjarlægja',
  'job.create.access.limitedaccess.header': 'Takmarkaður aðgangur',
  'job.create.access.limitedaccess.header.tooltip': 'Takmarkaðir notendur hafa aðeins aðgang að umsóknum sem þeim er bætt handvirkt á',
  'job.create.access.limitedaccess.subtitle': 'Aðgangur: {0} umsókn(ir)',
  'job.create.access.limitedaccess.remove.tooltip': 'Fjarlægja',
  'job.create.access.limitedaccess.empty': 'Engir notendur með takmarkaðan aðgang að þessu starfi.',

  'multiselect.nooptions': 'Engir valmöguleikar eftir',

  'jobs.nojobs.published': 'Engin störf í birtingu',
  'jobs.nojobs.expired': 'Engin útrunnin störf',
  'jobs.nojobs.drafts': 'Engin drög',
  'jobs.nojobs.archived': 'Engin störf í geymslu',
  'jobs.alljobs.published': 'Þú hefur ekki aðgang að neinum störfum í birtingu',
  'jobs.alljobs.expired': 'Þú hefur ekki aðgang að neinum útrunnum störfum',
  'jobs.alljobs.drafts': 'Þú hefur ekki aðgang að neinum drögum að störfum',
  'jobs.alljobs.archived': 'Þú hefur ekki aðgang að neinum störfum í geymslu',
  'jobs.tabs.mobile.display': 'Sýna: {0}',
  'jobs.search.placeholder': 'Leita...',
  'jobs.search.tip': 'Leita að starfi',

  'messages.list.header': 'Skilaboð',
  'messages.header.search.placeholder': 'Leita...',
  'messages.list.columns.applicationname': 'Nafn',
  'messages.list.columns.applicationemail': 'Netfang',
  'messages.list.columns.jobtitle': 'Starf',
  'messages.list.columns.jobstagename': 'Dálkur',
  'messages.list.columns.applicationstatus': 'Staða',
  'messages.list.columns.message': 'Skilaboð',
  'messages.list.columns.date': 'Dagsetning',
  'messages.list.columns.assignedto': 'Úthlutað á',
  'messages.list.columns.nummessages': '# Skilaboð',
  'messages.list.view': 'Skoða skilaboð',
  'messages.list.nomessages.header': 'Engin skilaboð',
  'messages.list.nomessages.content': 'Þegar umsækjandi sem þú hefur aðgang að sendir ný skilaboð munu þau birtast hér',
  'messages.list.status.active': 'Virk',
  'messages.list.status.hired': 'Ráðin/n',
  'messages.list.status.rejected': 'Hafnað',
  'messages.list.status.retracted': 'Dregin til baka',
  'messages.list.actions.markread': 'Merkja sem lesið',
  'messages.list.actions.markread.success': 'Skilaboð merkt sem lesin',
  'messages.list.actions.markread.error': 'Ekki tókst að merkja skilaboð sem lesin',
  'messages.list.actions.markunread': 'Merkja sem ólesið',
  'messages.list.actions.markunread.success': 'Skilaboð merkt sem ólesin',
  'messages.list.actions.markunread.error': 'Ekki tókst að merkja skilaboð sem ólesin',
  'messages.list.actions.assign': 'Úthluta umsækjanda',
  'messages.filters.showing': 'Sýni {0} / {1} skilaboð',
  'messages.filters.quick.new.title': 'Ólesin skilaboð',
  'messages.filters.quick.assignedtome.title': 'Umsækjanda úthlutað á mig',
  'messages.filters.quick.assignedtonoone.title': 'Umsækjanda óúhlutað',
  'messages.filters.date': 'Dagsetning',
  'messages.filters.date.title': 'Dagsetning',
  'messages.filters.name': 'Nafn umsækjanda',
  'messages.filters.name.title': 'Nafn umsækjanda',
  'messages.filters.email': 'Netfang umsækjanda',
  'messages.filters.email.title': 'Netfang umsækjanda',
  'messages.filters.job': 'Starf',
  'messages.filters.job.title': 'Starf',
  'messages.filters.job.state': 'Staða: {0}',
  'messages.filters.job.showing': 'Sýni fyrstu 8',
  'messages.filters.text': 'Skilaboð',
  'messages.filters.text.title': 'Skilaboð',
  'messages.filters.assigned.title': 'Úthlutað á',
  'messages.filters.assigned.me': 'Mig',
  'messages.filters.assigned.none': 'Engan',
  'messages.filters.assigned.anyone': 'Einhvern',
  'messages.filters.label': 'Merki',
  'messages.filters.label.title': 'Merki',
  'messages.filters.label.new': 'Ólesið',

  'forgotpw.reseterror': 'Vinsamlegast sláðu inn gilt netfang',
  'resetpw.submitting': 'Endurstilli lykilorð...',
  'setpw.error.notmatching': 'Lykilorðin eru ekki eins',
  'setpw.agree': 'Ég samþykki',
  'setpw.terms': 'þjónustuskilmála',
  'setpw.and': 'og',
  'setpw.privacypolicy': 'persónuverndarstefnu',
  'setpw.label.password': 'Lykilorð',
  'setpw.label.confirm': 'Staðfesta lykilorð',
  'setpw.twofactor.step1.label': 'Setja lykilorð',
  'setpw.twofactor.step1.heading': 'Velkomin/n í 50skills',
  'setpw.twofactor.step1.instruction': 'Vinsamlegast athugið, tveggja þátta auðkenning er virkjuð fyrir fyrirtækið þitt, þú munt þurfa auðkenningarforrit eins og Google Authenticator til að klára skráningu.',
  'setpw.twofactor.step1.hasauthenticatorapp': 'Ég er með auðkenningarforrit uppsett',
  'setpw.twofactor.step1.submit': 'Halda áfram',
  'setpw.twofactor.step2.label': 'Virkja 2FA',
  'setpw.twofactor.step2.heading': 'Vinsamlegast veldu lykilorð',
  'setpw.twofactor.step2.password.nomatch': 'Lykilorðin eru ekki þau sömu',
  'setpw.twofactor.step2.password.required': 'Nauðsynlegt er að fylla út þennan reit',
  'setpw.twofactor.step2.submit': 'Setja lykilorð',
  'setpw.twofactor.step3.heading': 'Tveggja þátta auðkenning',
  'setpw.twofactor.step3.qrcode.helptext': '1. Skannaðu QR kóðann',
  'setpw.twofactor.step3.code.helptext': '2. Sláðu inn 6 stafa kóðann hér fyrir neðan',
  'setpw.twofactor.step3.code.label': 'Kóði',
  'setpw.twofactor.step3.countrycode.label': 'Landakóði',
  'setpw.twofactor.step3.phone.label': 'Símanúmer (valkvæmt)',
  'setpw.twofactor.step3.phone.helptext': '3. Þú getur sett símanúmerið þitt sem varaleið',
  'setpw.twofactor.step3.submit': 'Auðkenna',
  'setpw.twofactor.step4.heading': 'Lykilorð sett og þú ert búin/n að virkja aðganginn',
  'setpw.twofactor.step4.subheading': 'Þú ert tilbúin/n',
  'setpw.twofactor.step4.submit': 'Opna 50skills',
  'pwsuccess.set.heading': 'Lykilorð vistað',
  'pwsuccess.reset.heading': 'Lykilorð endurstillt',
  'pwsuccess.instruction': 'þú getur nú skráð þig inn með netfanginu þínu og lykilorði',
  'pwsuccess.signin':'Skrá inn',
  'company.settings.career.theme.header': 'Þema',
  'company.settings.career.theme.description': 'Stilltu lógó og borða (banner) á ráðningarsíðu þíns fyrirtækis',
  'company.settings.career.theme.logo.title': 'Lógó fyrirtækis',
  'company.settings.career.theme.logo.description': 'Bættu við lógó fyrirtækis sem ætti að birtast í hausnum á ráðningarsíðunni.\nTil að ná sem bestum árangri skaltu nota mynd sem er að minnsta kosti 2x stærri en fyrirhuguð stærð.',
  'company.settings.career.theme.banner.title': 'Borði (banner) sem á að vera á ráðningarsíðu',
  'company.settings.career.theme.banner.description': 'Bættu við myndinni sem þú vilt birta í hausnum á ráðningarsíðunni.\n\nRáðlögð stærð er 2880 x 480 pixlar.',
  'company.settings.career.theme.logosize.title': 'Lógó stærð',
  'company.settings.career.theme.logosize.description': 'Við mælum með stærð á milli 24 og 40 pixla eftir hlutföllum lógósins',
  'company.settings.career.theme.logosize.label': 'Stærð',
  'company.settings.company.header': 'Fyrirtæki',
  'company.settings.jobboards.header': 'Starfatorg',
  'company.settings.jobboards.subtitle': 'Tengdu starfatorg og birtu störf beint úr 50skills.',
  'company.settings.departments.header': 'Deildir',
  'company.settings.departments.columns.title': 'Titill',
  'company.settings.departments.columns.externalid': 'Utanaðkomandi auðkenni',
  'company.settings.departments.columns.externalid.none': 'Ekkert auðkenni',
  'company.settings.departments.columns.numjobs': '# Störf',
  'company.settings.departments.columns.numusers': '# Notendur',
  'company.settings.departments.add': 'Bæta við deild',
  'company.settings.departments.add.disabled': 'Aðeins Ofur-notendur geta bætt við deildum',
  'company.settings.departments.actions.addusers': 'Nýir notendur',
  'company.settings.departments.actions.addusers.disabled': 'Þú hefur ekki aðgang að þessari deild',
  'company.settings.departments.actions.edit': 'Breyta',
  'company.settings.departments.actions.delete': 'Eyða',
  'company.settings.departments.actions.delete.disabled': 'Deild er með virk störf',
  'company.settings.departments.nodepartment': 'Engin deild',
  'company.settings.departments.nodepartments.header': 'Engar deildir',
  'company.settings.departments.nodepartments.content': 'Þú hefur ekki bætt við neinum deildum. Bættu við deildum til að flokka og aðgangsstýra störfum.',
  'company.settings.locations.header': 'Staðsetningar',
  'company.settings.locations.search.placeholder': 'Leita',
  'company.settings.locations.columns.title': 'Titill',
  'company.settings.locations.columns.title.notranslation': 'Vantar þýðingu',
  'company.settings.locations.columns.address': 'Heimilisfang',
  'company.settings.locations.columns.zipcode': 'Póstnúmer',
  'company.settings.locations.columns.city': 'Borg',
  'company.settings.locations.columns.state': 'Fylki',
  'company.settings.locations.columns.country': 'Land',
  'company.settings.locations.columns.externalid': 'Utanaðkomandi auðkenni',
  'company.settings.locations.columns.externalid.none': 'Ekkert auðkenni',
  'company.settings.locations.columns.numjobs': '# Störf',
  'company.settings.locations.add': 'Bæta við staðsetningu',
  'company.settings.locations.add.disabled': 'Aðeins Ofur-notendur geta bætt við staðsetningum',
  'company.settings.locations.actions.edit': 'Breyta',
  'company.settings.locations.actions.delete': 'Eyða',
  'company.settings.locations.actions.delete.disabled': 'Staðsetning er með virk störf',
  'company.settings.locations.actions.deactivate': 'Óvirkja',
  'company.settings.locations.actions.activate': 'Virkja',
  'company.settings.locations.nolocations.header': 'Engar staðsetningar',
  'company.settings.locations.nolocations.content': 'Þú hefur ekki bætt við neinum staðsetningum. Bættu við staðsetningum til að flokka og aðgangsstýra störfum.',
  'company.settings.locations.tabs.active': 'Virkur',
  'company.settings.locations.tabs.inactive': 'Óvirkur',
  'company.settings.locations.locationconflict.header': 'Nafn staðsetningar er í notkun',
  'company.settings.locations.locationconflict.samename': 'Önnur virk staðsetning hefur sama nafn á þessu tungumáli:',
  'company.settings.locations.locationconflict.samename.instruction': 'Til að virkja þessa staðsetningu þarftu að breyta nafninu eða óvirkja hina staðsetninguna.',
  'company.settings.locations.locationconflict.close': 'Loka',
  'company.settings.apps.noapps': 'Engin forrit tengd. Hafðu samband við okkur ef þú hefur áhuga á að skoða samþættingar við önnur forrit',
  'company.settings.apps.slack': 'Slack',
  'company.settings.apps.getaccept': 'GetAccept',
  'company.settings.apps.onboardingform': 'Onboarding Form',
  'company.settings.apps.kjarni': 'Kjarni',
  'company.settings.apps.asana': 'Asana',
  'company.settings.apps.hrmonitor': 'HR Monitor',
  'company.settings.apps.relesys': 'Relesys',
  'company.settings.apps.hireflix': 'Hireflix',
  'company.settings.apps.h3core': 'H3Core',
  'company.settings.apps.timon': 'Tímon',
  'company.settings.apps.mytimeplan': 'MyTimePlan',
  'company.settings.apps.dokobit': 'Dokobit',
  'company.settings.apps.onecrm': 'OneCRM',
  'company.settings.apps.admanager': 'AD Manager',
  'company.settings.apps.signet': 'Signet',
  'company.settings.apps.taktikal': 'Taktikal',
  'company.settings.root.details': 'Grunnupplýsingar',
  'company.settings.root.messagessendername.title': 'Nafn skilaboða',
  'company.settings.root.messagessendername.description': 'Sjálfgefið nafn sendanda tölvupósts fyrir öll skilaboð send frá 50 skills kerfinu.',
  'company.settings.root.messagessendername.placeholder': 'Nafn fyrirtækis',
  'company.settings.root.messagessendername.label': 'Nafn skilaboða',
  'company.settings.root.messagessendername.error': 'Þú verður að tilgreina nafn skilaboða',
  'company.settings.root.messagessendername.updateSuccess': 'Nafni skilaboða hefur verið breytt.',
  'company.settings.root.messagessendername.updateError': 'Villa við að breyta nafni skilaboða.',
  'company.settings.root.ga.title': 'Google tölfræði',
  'company.settings.root.ga.extendedtitle': 'Google tölfræði rakningarkóði',
  'company.settings.root.ga.description': 'Bættu Google tölfræði rakningarkóðanum þínum á ráðningarsíðuna.',
  'company.settings.root.ga.placeholder': 'Ekki stillt',
  'company.settings.root.ga.label': 'Rakningarkóði',
  'company.settings.root.ga.edit': 'Breyta',
  'company.settings.root.ga.remove': 'Fjarlægja rakningarkóða',
  'company.settings.root.ga.updateSuccess': 'Google Analytics rakningarkóði hefur verið breytt.',
  'company.settings.root.ga.updateError': 'Villa við að breyta Google Analytics rakningarkóða.',
  'company.settings.root.privacy.title': 'Friðhelgisstefnu slóð',
  'company.settings.root.privacy.description': 'Ef þú ert með persónuverndarstefnu, bættu slóðinni við hér og hún mun birtast neðst á umsóknarforminu á ráðningarsíðunni.',
  'company.settings.root.privacy.placeholder': 'Ekki stillt',
  'company.settings.root.privacy.label': 'Vefslóð',
  'company.settings.root.selectlangs': 'Velja tungumál',
  'company.settings.root.heading': 'Fyrirtækjaprófill',
  'company.settings.root.label.name': 'Nafn fyrirtækis',
  'company.settings.root.label.url': 'Fyrirtækjaslóð',
  'company.settings.root.label.deadline': 'Starf krefst umsóknarfrests',
  'company.settings.root.label.langs': 'Tungumál ráðningarsíðu',
  'company.settings.root.label.ssnvalidation': 'Vartöluprófun fyrir kennitölur í umsóknarformi (aðeins íslenskar kennitölur)',
  'company.settings.root.button.cancel': 'Hætta við',
  'company.settings.root.button.submit': 'Vista',
  'company.settings.root.updateSuccess': 'Fyrirtækjaupplýsingum hefur verið breytt.',
  'company.settings.root.updateError': 'Villa við að breyta fyrirtækjaupplýsingum.',
  'company.settings.root.companyname.required': 'Nauðsynlegt er að setja nafn',
  'company.settings.root.url.error': 'Fyrirtækjaslóð er ekki á réttu formi',
  'company.settings.root.deadline.title': 'Umsóknarfrestur',
  'company.settings.root.deadline.description': 'Þegar þessi stilling er virk er ekki hægt að búa til störf án umsóknarfrests',
  'company.settings.root.deadline.required': 'Umsóknarfrests krafist',
  'company.settings.root.deadline.enabled': 'Virkt',
  'company.settings.root.deadline.disabled': 'Óvirkt',
  'company.settings.career.header': 'Stillingar fyrir ráðningarsíðu',
  'company.settings.career.languages': 'Tungumál',
  'company.settings.career.image': 'Sjálfgefin mynd fyrir samfélagsmiðla',
  'company.settings.career.description': 'Sjálfgefnar upplýsingar fyrir samfélagsmiðla',
  'company.settings.career.image.helptext': 'Þegar starf er auglýst á samfélagsmiðlum er notast við þessa mynd, nema henni sé breytt á stöku starfi\n\nFyrir bestu niðurstöður notist við \'landscape\' mynd: 1200 x 630 pixla. Við aðlögum myndina niður í 1200 ef myndir er breiðari. Hámarksstærð myndar er 5mb.',
  'company.settings.career.description.helptext': 'Sjálfgefinn titill og lýsingartexti sem birtist þegar þú deilir starfi á samfélagsmiðlum',
  'company.settings.career.update.logoheight.error': 'Villa við að uppfæra stærð lógós',
  'company.settings.career.update.logoheight.success': 'Stærð lógós uppfært',
  'company.settings.career.update.description.error': 'Villa við að uppfæra lýsingu',
  'company.settings.career.update.description.success': 'Lýsing uppfærð',
  'company.settings.career.social.title.label': 'Titill á deilingu',
  'company.settings.career.social.description.label': 'Lýsing á deilingu',
  'company.settings.career.languages.helptext.p2': 'Ráðningarsíðan mun bjóða umsækjendum um að skoða störf á mismunandi tungumálum ef þýðing er framkvæmd (per starf)',
  'company.settings.career.save.title.error': 'Nauðsynlegt er að fylla titil',
  'company.settings.career.save.description.error': 'Nauðsynlegt er að fylla lýsingu',
  'company.settings.save.empty.languages': 'Ekki tókst að vista. Vinsamlegast veldu að minnsta kosti eitt tungumál fyrir ráðningarsíðu.',
  'company.settings.joborder.heading': 'Starfaröðun á ráðningarsíðu',
  'company.settings.joborder.desciption': 'Festu ákveðin útgefin störf sem þú vilt sérstaklega raða á ráðningarsíðunni. Störf sem eru ekki fest eru röðuð eftir útgáfudegi fyrir neðan festu störfin.',
  'company.settings.joborder.pinned': 'Föst efst',
  'company.settings.joborder.pin.hover': 'Festa starf efst',
  'company.settings.joborder.unpin.hover': 'Ekki festa starf',
  'company.settings.joborder.unpinned': 'Ekki föst röð',
  'company.settings.joborder.pinned.none': 'Engin störf fest',
  'company.settings.joborder.unpinned.none': 'Engin störf eftir útgáfudegi',
  'company.settings.joborder.manually': 'Handvirk röðun',
  'company.settings.joborder.unpinned.order': 'Útgáfudagur starfs • nýjast fyrst',
  'company.settings.joborder.move.top': 'Færa efst',
  'company.settings.joborder.move.bottom': 'Færa neðst',
  'company.settings.joborder.toast.job': 'Starf endurraðað á ráðningarsíðu',
  'company.settings.joborder.toast.department': 'Deild endurraðað á ráðningarsíðu',
  'company.settings.joborder.toast.get.error': 'Ekki tókst að sækja störf',
  'company.settings.joborder.departments.unpinned.order': 'Útgáfudagur deildar • nýjast fyrst',
  'company.settings.joborder.departments.desciption': 'Festu ákveðin útgefin störf sem þú vilt sérstaklega raða á ráðningarsíðunni. Deildir og störf sem eru ekki fest eru röðuð eftir útgáfudegi fyrir neðan festu deildirnar og störfin.',
  'company.settings.joborder.departments.pinned': 'Fest efst í deild',
  'company.settings.joborder.departments.unpinned': 'Ófastar deildir',
  'company.settings.joborder.departments.pinned.none': 'Engar deildir festar',
  'company.settings.joborder.departments.unpinned.none': 'Engar deildir raðaðar eftir útgáfudegi',
  'company.settings.joborder.departments.jobs.none': 'Engin störf útgefin í deild',
  'company.settings.joborder.departments.pin.hover': 'Festa deild efst',
  'company.settings.joborder.departments.unpin.hover': 'Ekki festa deild',
  'sharejob.careersite.maintext': 'Þetta er varanlegur hlekkur sem vísar til 50skills ráðningarsíðu þíns fyrirtækis. Þetta er ráðlögð leið til að deila störfum.',
  'sharejob.careersite.title': 'Deila ráðningarsíðu',
  'sharejob.header.crumb.root': 'Deila',
  'sharejob.header.sharing.title': 'Deila á samfélagsmiðlum',
  'sharejob.header.crumb.careers': 'Ráðningarsíða',
  'sharejob.button.careers': 'Deila ráðningarsíðu',
  'sharejob.tips.reward': 'Verðlaun í boði fyrir tilvísun sem leiðir til ráðningar',
  'sharejob.tips.social': 'Deila á samfélagsmiðlum',
  'sharejob.button.submit': 'Deila starfi',
  'sharejob.label': 'Umsækjendur sem sækja um í gegnum þína persónulegu tilvísunarslóð verða merktir í kerfinu sem sóttir af þér.', 
  'signin.error': 'Rangt netfang eða lykilorð',
  'modals.sso.header': 'Skrá inn í 50skills með SSO',
  'modals.sso.email': 'Netfang',
  'modals.sso.errors.account_not_configured': 'Þinn notandi er ekki stilltur til að nota SSO auðkenningu. Vinsamlegast skráðu þig inn með lykilorði.',
  'modals.sso.errors.company_not_configured': 'Þitt fyrirtæki er ekki stillt til að nota SSO auðkenningu. Vinsamlegast hafið samband við 50skills til að virkja þennan möguleika.',
  'modals.sso.button.cancel': 'Hætta við',
  'modals.sso.button.signin': 'Skrá inn',
  'signin.twofactor.heading': 'Auðkenning',
  'signin.twofactor.subheading': 'Skráðu kóðann úr auðkenningarforritinu þínu',
  'signin.twofactor.label.code': 'Kóði',
  'signin.twofactor.button.submit': 'Staðfesta',
  'signin.twofactor.button.submitting': 'Staðfesti...',
  'signin.twofactor.button.sendingsms': 'Sendi sms...',
  'signin.twofactor.sms': 'Senda SMS með kóða',
  'signin.sms.heading': 'SMS auðkenning',
  'signin.sms.subheading': 'Sláðu inn kóðann sem þú fékkst sendan í sms',
  'slack.success.bot': 'Slack Bot tilbúinn',
  'slack.success.user': 'Slack aðgangur tengdur',

  'user.unknown': 'Óþekktur notandi',

  'user.create.heading': 'Búa til nýjan notanda',
  'user.create.label.name': 'Nafn',
  'user.create.label.email': 'Netfang',
  'user.create.label.role': 'Hlutverk',
  'user.role.user.help': 'Hefur aðeins aðgang að ráðningarsíðu',
  'user.role.limited.help': 'Hefur aðeins aðgang að völdum umsóknum',
  'user.role.recruiter.help': 'Getur séð og unnið með valin störf',
  'user.role.admin.help': 'Full réttindi til að búa til og breyta störfum ásamt aðgangsstýringu notenda',
  'user.role.superadmin.help': 'Ótakmarkaður aðgangur að öllum störfum, umsækjendum og notendum',

  'user.sendinvite.error': 'Ekki tókst að senda boð, vinsamlegast hafið samband við 50skills',
  'user.sendinvite.success': 'Boð sent',

  'user.create.sendinvite.toggle': 'Senda boð í tölvupósti',
  'user.create.addtonewjobs.toggle': 'Bæta sjálfvirkt við á ný störf',
  'user.create.addtonewjobs.tooltip': 'Þessi notandi verður sjálfkrafa í ráðningarteymi fyrir öll ný störf',
  'user.create.addtohiredapplications.toggle': 'Bæta sjálfvirkt á ráðna umsækjendur',
  'user.create.addtohiredapplications.tooltip': 'Þessi notandi fær aðgang að öllum ráðnum einstaklingum í störfum sem hann hefur takmarkaðan aðgang',
  'user.create.button.cancel': 'Hætta við',
  'user.create.button.submit': 'Vista',

  'user.edit.update.errors': 'Ekki tókst að breyta notanda. Athugaðu villur í formi eða hafðu samband við 50skills.',
  'user.edit.update.success': 'Notandi uppfærður',
  'user.edit.heading': 'Breyta notanda',
  'user.accessform.heading': 'Aðgangur',
  'user.accessform.applicants': 'Umsækjendur',
  'user.accessform.draft': 'Drög',
  'user.accessform.select': 'Velja allt',
  'user.accessform.deselect': 'Afvelja allt',

  'user.tabs.all': 'Allir notendur',
  'user.tabs.superadmins': 'Ofur-notendur',
  'user.tabs.admins': 'Stjórnendur',
  'user.tabs.recruiters': 'Ráðningarstjórar',
  'user.tabs.limited': 'Takmarkaðir notendur',
  'user.tabs.employees': 'Starfsmenn',
  'user.tabs.mobile.display': 'Sýna: {0}',
  'user.button.create': 'Bæta við notanda',
  'user.search.tip': 'Leita',

  'user.status.joined': 'Tengdur',
  'user.status.created': 'Stofnaður',
  'user.status.invited': 'Boðið',
  'user.access.loading': 'Hleð...',
  'user.access.all': 'Allt',
  'user.access.sharingonly': 'Einungis ráðningarsíða',
  'user.access.jobs.singular': 'starf',
  'user.access.jobs.plural': 'störf',
  'user.access.apps.singular': 'umsókn',
  'user.access.apps.plural': 'umsóknir',
  'user.options.edit': 'Breyta',
  'user.options.view': 'Prófíll',
  'user.options.delete': 'Eyða',
  'user.options.invite': 'Senda boð',
  'user.crumbs.team': 'Teymi',
  'user.tabs.profile': 'Prófíll',
  'user.tabs.security': 'Öryggi',
  'user.tabs.notifications': 'Tilkynningar',
  'user.tabs.twofactor': 'Fjöl-auðkenning',
  'user.changepw.heading': 'Breyta lykilorði',
  'user.twofactor.heading': 'Tvíþætt auðkenning',
  'user.twofactor.subheading': 'Gerðu aðganginn þinn ennþá öruggari með tvíþættri auðkenningu',
  'user.twofactor.label.authenticator': 'Auðkenningar forrit',
  'user.twofactor.label.authenticator.connected': 'Tengt',
  'user.twofactor.label.code': '6 Stafa Kóði frá forritinu',
  'user.twofactor.label.phone': 'Símanúmer',
  'user.twofactor.button.addauthenticator': 'Bæta við auðkenningarforriti',
  'user.twofactor.button.addsms': 'Bæta við SMS varaleið',
  'user.twofactor.button.submit': 'Staðfesta',
  'user.twofactor.success': 'Tæki vistað',

  'user.list.empty.header': 'Engir notendur',
  'user.list.empty.content': 'Engir notendur fundust fyrir núverandi síu',
  'user.list.departments.none': 'Engin deild',

  'profile.apps.subheader': '50skills API er í virkri þróun.',
  'profile.apps.subheader.docs': 'API skjölun',
  'profile.apps.heading': '50skills API',
  'profile.apps.personal': 'Persónulegur API lykill',
  'profile.apps.personal.info': 'Búðu til persónulega lykla til að fá aðgang að og sannvotta við ytri API 50skills.',
  'profile.apps.header': 'Apps',
  'profile.apps.loading.error': 'Ekki tókst að sækja apps',
  'profile.apps.add': 'Bættu við nýju Appi',
  'profile.apps.menu.remove': 'Fjarlægja app',

  'notifications.title': 'Tilkynningar',
  'notifications.search.placeholder': 'Leita...',
  'notifications.tabs.label': 'Tilkynninga sía',
  'notifications.tabs.activity': 'Virkar',
  'notifications.tabs.archive': 'Geymsla',
  'notifications.filters.all': 'Allt',
  'notifications.filters.unread': 'Ólesið',
  'notifications.filters.newapplications': 'Nýjar umsóknir',
  'notifications.filters.assigned': 'Úthlutað á mig',
  'notifications.empty.header': 'Engar tilkynningar',
  'notifications.empty.content': 'Við munum sýna þér tilkynningar hér þegar þær koma',
  'notifications.title.markallasread': 'Merkja allar sem lesnar',
  'notifications.title.archiveall': 'Setja allar í geymslu',
  'notifications.modals.markasread.header': 'Merkja tilkynningar sem lesnar',
  'notifications.modals.markasread.text': 'Ertu viss um að þú viljir merkja allar tilkynningar sem lesnar?',
  'notifications.modals.markasread.success': 'Allar tilkynningar merktar sem lesnar',
  'notifications.modals.markasread.error': 'Ekki tókst að merkja tilkynningar sem lesnar, reyndu aftur síðar',
  'notifications.modals.archiveall.header': 'Setja í geymslu',
  'notifications.modals.archiveall.text': 'Ertu viss um að þú viljir setja allar tilkynningar í geymslu?',
  'notifications.modals.archiveall.success': 'Allar tilkynningar settar í geymslu',
  'notifications.modals.archiveall.error': 'Ekki tókst að setja tilkynningar í geymslu, reyndu aftur síðar',
  'notifications.tooltips.markasread': 'Merkja sem lesin',
  'notifications.tooltips.markasunread': 'Merkja sem ólesin',
  'notifications.tooltips.archive': 'Setja í geymslu',
  'notifications.tooltips.unarchive': 'Taka úr geymslu',
  'notifications.tooltips.settings': 'Stillingar',
  'notifications.tooltips.close': 'Loka',
  'notifications.new_notifications.singular': 'Ný tilkynning',
  'notifications.new_notifications.plural': 'Nýjar tilkynningar',
  'notifications.single.applicant_hired': 'hefur merkt',
  'notifications.single.applicant_as_hired': 'sem ráðin/n',
  'notifications.single.applicant_rejected': 'hefur merkt',
  'notifications.single.applicant_rejected_as': 'sem hafnað',
  'notifications.single.applicant_assigned': 'úthlutaði umsækjanda,',
  'notifications.single.applicant_assigned_to': ', á þig',
  'notifications.single.move_stage': 'færði',
  'notifications.single.move_stage_from': 'frá dálki',
  'notifications.single.move_stage_to': 'til',
  'notifications.single.job_archived': 'setti starf í geymslu',
  'notifications.single.job_published': 'gaf út nýtt starf',
  'notifications.single.job_expired': 'Starf er runnið út',
  'notifications.single.added': 'bætti',
  'notifications.single.you': 'Þér',
  'notifications.single.to_hiring_team': 'í ráðningateymi',
  'notifications.single.new_applications': 'Ný umsókn: ',
  'notifications.single.add_rating': 'setti inn nýja einkunn á umsækjanda',
  'notifications.single.add_note': 'setti inn nýja umsögn á umsækjanda',
  'notifications.single.add_note_mention': 'minntist á þig í umsögn á umsækjandanum',
  'notifications.single.bulk_reject': 'hafnaði',
  'notifications.single.bulk_reject_applicants': 'umsækjendum',
  'notifications.addtoapplication': 'gaf þér aðgang á umsókn, ',
  'notifications.integrations.onboarding_form.send': 'sendi onboarding form á',
  'notifications.integrations.onboarding_form.finished_new': 'Nýr starfsmaður',
  'notifications.integrations.onboarding_form.finished_has': 'hefur skilað inn onboarding formi',
  'notifications.integrations.signet.finished_new': 'Nýr stafsmaður',
  'notifications.integrations.signet.finished_has': 'hefur skrifað undir Signet samning',
  'notifications.single.message': 'Ný skilaboð á umsækjanda',
  'notifications.single.add_job_note': 'bætti við skilaboði á starf',
  'notifications.single.add_job_note_mention': 'minntist á þig í skilaboði á starf',

  'user.profile.error.email': 'Ógilt netfang slegið inn.',
  'user.profile.error.generic': 'Ekki tókst að breyta notanda. {0} Vinsamlegast hafið samband við 50skills.',
  'user.profile.update.success': 'Notendastillingar vistaðar',
  'user.profile.label.image': 'Prófílmynd',
  'user.profile.image.choose': 'Veldu mynd',
  'user.profile.image.nofile': 'Engin mynd valin',
  'user.profile.label.name': 'Nafn',
  'user.profile.label.email': 'Netfang',
  'user.profile.label.language': 'Tungumál',
  'user.profile.label.language.english': 'Enska',
  'user.profile.label.language.icelandic': 'Íslenska',
  'user.profile.button.cancel': 'Hætta við',
  'user.profile.button.submit': 'Vista',
  'user.social.heading': 'Samfélagsmiðlar',

  'user.profile.settings.notifications.mail.header': 'Tölvupóstur',
  'user.profile.settings.notifications.mail.text': 'Tilkynning send í tölvupóstinn þinn',
  'user.profile.settings.notifications.inapp.header': 'Í kerfi',
  'user.profile.settings.notifications.inapp.text': 'Tilkynning niðri í vinstra horni kerfisins',
  'user.profile.settings.notifications.activity.header': 'Tilkynningar',
  'user.profile.settings.notifications.activity.subheader': 'Fáðu tilkynningar fyrir umsækjendur og aðra virkni',
  'user.profile.settings.notifications.table.header.notify': 'Senda tilkynningu þegar',
  'user.profile.settings.notifications.table.header.mail': 'Póstur',
  'user.profile.settings.notifications.table.header.inapp': 'Í kerfi',
  'user.profile.settings.notifications.table.applicant.header': 'Tilkynningar fyrir umsækjendur',
  'user.profile.settings.notifications.table.applicant.applies': 'Umsækjandi sækir um starf',
  'user.profile.settings.notifications.table.applicant.movestage': 'Umsækjandi er færður um dálk',
  'user.profile.settings.notifications.table.applicant.addtohiringteam': 'Þér er bætt í ráðningarteymi',
  'user.profile.settings.notifications.table.applicant.addtoapplication': 'Þér er gefinn aðgangur að umsækjanda',
  'user.profile.settings.notifications.table.applicant.bulkrejectapplicants': 'Umsækjendum er fjölhafnað (group reject)',
  'user.profile.settings.notifications.table.applicant.addrating': 'Umsækjandi fær einkunn',
  'user.profile.settings.notifications.table.applicant.addnote': 'Umsækjandi fær nýja umsögn',
  'user.profile.settings.notifications.table.applicant.addnotemention': 'Það er minnst á þig í umsögn á umsækjanda',
  'user.profile.settings.notifications.table.applicant.applicanthired': 'Umsækjandi er ráðinn',
  'user.profile.settings.notifications.table.applicant.applicantrejected': 'Umsækjanda er hafnað',
  'user.profile.settings.notifications.table.applicant.applicantassigned': 'Umsækjandi er úthlutaður á þig (assigned)',
  'user.profile.settings.notifications.table.applicant.applicationmessage': 'Umsækjandi sendir inn ný skilaboð',
  'user.profile.settings.notifications.table.applicant.applicationassignedmessage': 'Umsækjandi sem er úthlutaður á þig sendir inn ný skilaboð',
  'user.profile.settings.notifications.table.job.header': 'Tilkynningar fyrir störf',
  'user.profile.settings.notifications.table.job.publishjob': 'Starf er gefið út',
  'user.profile.settings.notifications.table.job.archivejob': 'Starf er sett í geymslu',
  'user.profile.settings.notifications.table.job.expirejob': 'Starf rennur út',
  'user.profile.settings.notifications.table.job.addjobnote': 'Athugasemd bætt á starf',
  'user.profile.settings.notifications.table.job.addjobnotemention': 'Það er minnst á þig í athugasemd á starfi',
  'user.profile.settings.notifications.table.onboarding.header': 'Tilkynningar fyrir onboarding',
  'user.profile.settings.notifications.table.onboarding.integration': 'Onboarding form er sent út eða skilað af umsækjanda',
  'user.profile.settings.notifications.save.success': 'Stilling vistuð',
  'user.profile.settings.notifications.save.error': 'Ekki tókst að vista stillingar',

  'company.templates.default.yes': 'Já',
  'company.templates.default.no': 'Nei',
  'company.templates.tasklist.header': 'Aðgerðalistar',
  'company.templates.tasklist.label.name': 'Nafn',
  'company.templates.tasklist.menu.edit': 'Breyta sniðmáti',
  'company.templates.crumbs.root': 'Sniðmát',
  'company.templates.crumbs.new': 'Nýtt sniðmát',
  'company.templates.tabs.tasks': 'Aðgerðir',
  'company.templates.tabs.label': 'Sniðmátsval',
  'company.templates.tabs.emails': 'Tölvupóstar',
  'company.templates.emails.new': 'Nýtt tölvupósta sniðmát',
  'company.templates.tasks.new': 'Nýtt aðgerðarlista sniðmát',
  'company.templates.options.edit': 'Breyta',
  'company.templates.options.delete': 'Eyða',
  'company.templates.update.success': 'Aðgerðarlisti uppfærður',
  'company.templates.update.error': 'Ekki tókst að breyta aðgerðarlista. Vinsamlegast hafið samband við 50skills.',
  'company.templates.create.success': 'Aðgerðarlisti stofnaður',
  'company.templates.create.error': 'Ekki tókst að stofna aðgerðarlista. Vinsamlegast hafið samband við 50skills.',
  'company.templates.tasks.create': 'Bæta við aðgerð',
  'company.templates.button.back': 'Til baka',
  'company.templates.button.cancel': 'Hætta við',
  'company.templates.button.submit': 'Vista',
  'company.templates.tasks.label.title': 'Titill',
  'company.templates.tasks.label.title.placeholder': 'Nafn aðgerðar',
  'company.templates.tasks.label': 'Nafn aðgerðar',
  'company.templates.button.add.task': 'Bæta við',
  'company.templates.button.update.task': 'Uppfæra',
  'company.templates.button.cancel.task': 'Hætta við',
  'company.templates.tasks.label.tasks': 'Aðgerðir',
  'company.templates.type.applicant_new_application': 'Ný umsókn',
  'company.templates.type.rejection': 'Hafna',
  'company.templates.type.message': 'Skilaboð',
  'company.templates.email.tabs.all': 'Öll sniðmát',
  'company.templates.email.tabs.new_application': 'Umsókn móttekin',
  'company.templates.email.tabs.rejection': 'Umsókn hafnað',
  'company.templates.email.tabs.message': 'Skilaboð',
  'company.templates.email.button.cancel': 'Hætta við',
  'company.templates.email.button.save': 'Vista',
  'company.templates.email.button.back': 'Aftur tilbaka',
  'company.templates.email.create.error': 'Ekki tókst að búa til sniðmát. Vinsamlegast hafið samband við 50skills.',
  'company.templates.email.create.success': 'Sniðmát stofnað',
  'company.templates.email.create.success.default': 'Sniðmát stofnað og sett sem sjálfgefinn svarpóstur fyrir allar umsóknir',
  'company.templates.email.delete.error': 'Ekki tókst að eyða sniðmáti. Vinsamlegast hafið samband við 50skills.',
  'company.templates.email.delete.success': 'Sniðmáti hefur verið eytt.',
  'company.templates.email.delete.text': 'Ertu viss um að þú viljir fjarlægja sniðmát',
  'company.templates.email.menu.delete': 'Eyða sniðmáti',
  'company.templates.email.menu.view': 'Skoða sniðmát',
  'company.templates.email.menu.edit': 'Breyta sniðmáti',
  'company.templates.email.message.placeholder': 'Búa til nýtt sniðmát fyrir tölvupóst',
  'company.templates.email.title.placeholder': 'Veldu lýsandi titil á sniðmátið',
  'company.templates.email.subject.placeholder': 'Lýsandi texti fyrir tölvupóstinn',
  'company.templates.email.update.error': 'Ekki tókst að uppfæra sniðmát. {0}.',
  'company.templates.email.update.success': 'Sniðmát uppfært',
  'company.templates.email.update.success.default': 'Sniðmátt uppfært og sett sem sjálfgefinn svarpóstur fyrir allar umsóknir',
  'company.templates.email.label.message': 'Skilaboð',
  'company.templates.email.label.title': 'Titill',
  'company.templates.email.label.type': 'Tegund',
  'company.templates.email.label.default': 'Sjálfvalið',
  'company.templates.email.label.options': 'Valmöguleikar',
  'company.templates.email.type.title': 'Veldu tegund',
  'company.templates.email.label.setdefault': 'Setja sem sjálfgefinn svarpóst fyrir allar umsóknir',
  'company.integrations.configured_apps': 'Tengd apps',
  'company.integrations.upsell.title': 'Fleiri tengingar mögulegar',
  'company.integrations.none': 'Engin apps tengd',
  'company.integrations.upsell.body': 'Til að tengjast samskiptaforritum eins og Workplace og Slack eða tengjast mannauðslausnum, vinsamlegast hafið samband við okkur.',
  'company.integrations.detail.hired': 'Ráðin/n • {0} • af {1}',

  'comparers.is': 'Er...',
  'comparers.not_is': 'Er ekki...',
  'comparers.any_of': 'Er eitthvað af...',
  'comparers.none_of': 'Er ekkert af...',
  'comparers.starts': 'Byrjar á...',
  'comparers.not_starts': 'Byrjar ekki á...',
  'comparers.contains': 'Inniheldur',
  'comparers.not_contains': 'Inniheldur ekki',

  'comparers.is_rated_by': 'Hefur gefið einkunn...',
  'comparers.not_is_rated_by': 'Hefur ekki gefið einkunn...',
  'comparers.is_none': 'Engin einkunn',

  'comparers.today': 'Í dag',
  'comparers.yesterday': 'Í gær',
  'comparers.gt': 'Meira en',
  'comparers.between': 'Milli',
  'comparers.eq': 'Nákvæmlega',
  'comparers.lt': 'Minna en',
  'comparers.after': 'Eftir',
  'comparers.on': 'Þann',
  'comparers.before': 'Fyrir',

  'filters.daysago': 'dögum síðan',
  'filters.years': 'ár',
  'filters.loading': 'Hleð...',
  'filters.add': 'Bæta við síu',
  'filters.clear': 'Hreinsa síur',
  'filters.conj.and': 'Og',
  'filters.conj.or': 'Eða',
  'filters.remove': 'Eyða',
  'filters.update': 'Uppfæra síu',
  'filters.apply': 'Bæta við síu',
  'filters.toggle': 'Síur',

  'applicants.status.title': 'Staða',
  'applicants.status.active': 'Virk',
  'applicants.status.hired': 'Ráðin/n',
  'applicants.status.rejected': 'Hafnað',
  'applicants.status.retracted': 'Dregin til baka',
  
  'applicants.filters.stage.label': 'Dálkur',
  'applicants.filters.question.label': 'Spurningar',

  'applicants.filters.language.label': 'Tungumál',

  'applicants.filters.integrations.all': 'Allar',
  'applicants.filters.integrations.not_started': 'Ekki hafið',
  'applicants.filters.integrations.in_progress': 'Í vinnslu',
  'applicants.filters.integrations.completed': 'Lokið',

  'applicants.filters.job.title': 'Starf',
  'applicants.filters.job.notitle': 'Enginn titill settur',
  'applicants.filters.job.state': 'Staða: {0}',
  'applicants.filters.job.showing': 'Sýni fyrstu 8',

  'applicants.filters.integration.title': 'Samþættingar',

  'applicants.filters.personal.title': 'Persónuupplýsingar',
  'applicants.filters.personal.name': 'Nafn',
  'applicants.filters.personal.email': 'Netfang',
  'applicants.filters.personal.phone': 'Sími',
  'applicants.filters.personal.cv': 'Ferilskrá',
  'applicants.filters.personal.cover_letter': 'Kynningarbréf',
  'applicants.filters.personal.notes': 'Umsagnir',
  'applicants.filters.personal.messages': 'Skilaboð',


  'applicants.filters.assigned.title': 'Úthlutað á',
  'applicants.filters.assigned.me': 'Mig',
  'applicants.filters.assigned.none': 'Engan',
  'applicants.filters.assigned.anyone': 'Einhvern',

  'applicants.filters.date.title': 'Dagsetning',
  'applicants.filters.date.hired': 'Ráðin/n',
  'applicants.filters.date.rejected': 'Hafnað',
  'applicants.filters.date.applied': 'Sótt um',
  'applicants.filters.date.rel': 'Miða við',
  'applicants.filters.date.abs': 'Dagsetning',

  'applicants.filters.label.title': 'Merki',
  'applicants.filters.label.notified': 'Hafnað og tilkynnt',
  'applicants.filters.label.sourced': 'Sótt',
  'applicants.filters.label.manuallyadded': 'Handvirkt bætt við',

  'applicants.filters.rating.title': 'Meðaleinkunn',
  'applicants.filters.rating.-': 'Engin einkunn',
  'applicants.filters.rating.S': 'Sterkt já',
  'applicants.filters.rating.Y': 'Já',
  'applicants.filters.rating.N': 'Nei',
  'applicants.filters.rating.D': 'Sterkt nei',
  'applicants.filters.rating.withoutmine': 'Ég hef ekki gefið einkunn',
  'applicants.filters.rating.withmine': 'Ég hef gefið einkunn',

  'applicants.filters.unread.title': 'Ólesin virkni',
  'applicants.filters.unread.new_application': 'Ný umsókn',
  'applicants.filters.unread.messages': 'Skilaboð',
  'applicants.filters.unread.notes': 'Umsagnir',
  'applicants.filters.unread.ratings': 'Einkunnir',
  'applicants.filters.unread.assigned_to': 'Úthlutun',
  'applicants.filters.unread.files': 'Skrár',

  'applicants.filters.showing': 'Sýni {0} / {1} umsóknir',

  'applicants.filters.national_registry.title': 'Þjóðskrá',
  'applicants.filters.national_registry.name': 'Nafn',
  'applicants.filters.national_registry.gender': 'Kyn',
  'applicants.filters.national_registry.ssn': 'Kennitala',
  'applicants.filters.national_registry.age': 'Aldur',
  'applicants.filters.national_registry.age_year_end': 'Aldur við lok árs',
  'applicants.filters.national_registry.street': 'Gata',
  'applicants.filters.national_registry.city': 'Borg / Bær',
  'applicants.filters.national_registry.postal_code': 'Póstnúmer',

  'applicants.header.search.placeholder': 'Nafn, netfang, sími...',
  'applicants.header.filter': 'Síur',
  'applicants.header.hideall': 'Fela allt',
  'applicants.header.expandall': 'Sýna allt',

  'applicants.empty.header': 'Engir umsækjendur',
  'applicants.empty.content': 'Þegar umsækjandi sækir um eitt af störfunum þínum birtast þeir hér',

  'onboarding.tabs.label': 'Staða onboarding',
  'onboarding.tabs.in_progress': 'Í vinnslu',
  'onboarding.tabs.completed': 'Lokið',
  'onboarding.empty.header': 'Engir umsækjendur í onboarding',
  'onboarding.empty.content': 'Þegar þú ræður umsækjanda birtast þeir hér',
  'onboarding.empty.completed.header': 'Engir umsækjendur hafa lokið onboarding',
  'onboarding.empty.completed.content': 'Þegar umsækjandi lýkur onboarding birtist hann hér',
  'onboarding.filters.header': 'Onboarding síur:',
  'onboarding.filters.sub_header': 'Sýni {0} ráðna umsækjendur',
  'onboarding.sidebar.title.integrations': 'Staða samþættingar',
  'onboarding.none_found.no_filters.header': 'Engir umsækjendur í onboarding',
  'onboarding.none_found.filters.header': 'Engir umsækjendur fundust',
  'onboarding.none_found.no_filters.sub_header': 'Það eru engir umsækjendur í onboarding ferli',
  'onboarding.none_found.filters.sub_header': 'Engir umsækjendur finnast undir þessum síu stillingum',
  'job.filters.numfilteredout': '{0} umsækjendur síaðir út',
  'job.filters.clear': 'Hreinsa síur',
  'job.filters.empty': 'Engir umsækjendur síaðir út',
  'job.tabs.label': 'Starfsval',
  'job.tabs.pipeline': 'Dálkar',
  'job.tabs.promote': 'Starfatorg',
  'job.tabs.applicants': 'Listasýn',
  'job.tabs.info': 'Upplýsingar',
  'job.tabs.access': 'Aðgangsmál',
  'job.tabs.statistics': 'Tölfræði',
  'job.tabs.integrations': 'Apps',
  'job.tabs.journeys': 'Journey-ferli',
  'job.addapplicant': 'Bæta við umsækjanda',
  'job.access.manage': 'Stjórna aðgangi',
  'job.access.editaccess.addapplicant': 'Bæta við umsækjanda',
  'errors.field.required': 'Nauðsynlegt er að fylla út þennan reit',
  'modals.addapplicant.header': 'Bæta við umsækjanda',
  'modals.addapplicant.label.name': '',
  'modals.addapplicant.button.cancel': 'Hætta við',
  'modals.addapplicant.button.submit': 'Vista',
  'modals.addapplicant.field.cv': 'Ferilskrá',
  'modals.addapplicant.field.cover': 'Kynningarbréf',
  'modals.addrecruiter.heading': 'Bæta við í ráðningarteymi',
  'modals.addrecruiter.select.empty': 'Engir notendur tiltækir',
  'modals.addrecruiter.select': 'Veldu notendur til að bæta við',
  'modals.addrecruiter.button.cancel': 'Hætta við',
  'modals.addrecruiter.button.submit': 'Bæta við',
  'job.applicants.show.selected': "{0} umsóknir valdar á síðu",
  'job.applicants.show.selected.all': "Allar {0} umsóknir valdar",
  'job.applicants.selection.clear': "Hreinsa val",
  'job.applicants.filtered.applicants': "Velja allar {0} umsóknir",
  'job.applicants.empty': 'Engir umsækjendur',
  'job.applicants.empty.search': 'Engir umsækjendur fundust',
  'job.applicants.msg.search': 'Engir umsækjendur finnast fyrir þessa síu',
  'job.applicants.msg.all': 'Allir umsækjendur munu birtast hér',
  'job.applicants.msg.rejected': 'Umsóknum sem verður hafnað munu birtast hér',
  'job.applicants.label.name' : 'Nafn',
  'job.applicants.label.email' : 'Netfang',
  'job.applicants.label.job' : 'Starf',
  'job.applicants.label.applied' : 'Sótt um',
  'job.applicants.label.stage' : 'Dálkur',
  'job.applicants.label.reviews' : '# Einkunnir',
  'job.applicants.label.avgrating' : 'Meðaleinkunn',
  'job.applicants.label.messages' : '# Skilaboð',
  'job.applicants.label.notes' : '# Umsagnir',
  'job.applicants.label.options' : 'Val',
  'job.applicants.label.status' : 'Staða',
  'job.applicants.label.labels' : 'Merki',


  'job.info.tabs.details': 'Upplýsingar',
  'job.info.tabs.notes': 'Athugasemdir',
  'job.info.tabs.files': 'Skrár',
  'job.info.details.header': 'Starfsupplýsingar',
  'job.info.details.language.english': 'Enska',
  'job.info.details.language.icelandic': 'Íslenska',
  'job.info.details.jobdetails.header': 'Starfsauglýsing',
  'job.info.details.jobdetails.jobtitle': 'Starfstitill',
  'job.info.details.jobdetails.worktype': 'Tegund starfs',
  'job.info.details.jobdetails.location': 'Staðsetning',
  'job.info.details.jobdetails.department': 'Deild',
  'job.info.details.jobdetails.jobstatus': 'Staða starfs',
  'job.info.details.jobdetails.visibility': 'Sýnileiki starfs',
  'job.info.details.jobdetails.deadline': 'Umsóknarfrestur',
  'job.info.details.jobdetails.published': 'Síðast birt',
  'job.info.details.jobdetails.createdby': 'Stofnað af',
  'job.info.details.jobdetails.labels': 'Merki starfs',
  'job.info.details.jobdescription.header': 'Starfslýsing',
  'job.info.details.jobdescription.shortdescription': 'Stutt starfslýsing',
  'job.info.details.jobdescription.longdescription': 'Löng starfslýsing',
  'job.info.details.applicationform.header': 'Umsóknarform',
  'job.info.details.applicationform.name': 'Nafn',
  'job.info.details.applicationform.email': 'Netfang',
  'job.info.details.applicationform.ssn': 'Kennitala',
  'job.info.details.applicationform.phone': 'Símanúmer',
  'job.info.details.applicationform.cv': 'Ferilsskrá',
  'job.info.details.applicationform.coverletter': 'Kynningarbréf',
  'job.info.details.applicationform.options.alwaysrequired': 'Alltaf nauðsynlegt',
  'job.info.details.applicationform.options.required': 'Nauðsynlegt',
  'job.info.details.applicationform.options.optional': 'Valkvætt',
  'job.info.details.applicationform.options.off': 'Óvirkt',
  'job.info.details.questions.header': 'Spurningar',

  'job.info.notes.header': 'Athugasemdir',
  'job.info.notes.textbox.adminnote.label': 'Stjórnendaathugasemd',
  'job.info.notes.textbox.switch.admin': 'Stjórnendaathugasemd',
  'job.info.notes.textbox.info': 'Stjórnendaathugasemd er aðeins sýnileg stjórnendum',
  'job.info.notes.adminonly': 'Aðeins sýnilegt stjórnendum',
  'job.info.notes.textbox.placeholder.admin': 'Bæta við stjórnendaathugasemd - aðeins aðrir stjórnendur með aðgang að þessu svæði sjá þessar athugasemdir',
  'job.info.notes.textbox.placeholder.regular': 'Bættu við athugasemd, þú getur notað @ merkið til að láta samstarfsmenn þín vita',
  'job.info.notes.textbox.button.submit.admin': 'Vista stjórnendaathugasemd',
  'job.info.notes.textbox.button.submit.regular': 'Vista athugasemd',
  'job.info.notes.edit.button.cancel': 'Hætta við',
  'job.info.notes.edit.button.submit': 'Uppfæra',
  'job.info.notes.actions.edit': 'Breyta',
  'job.info.notes.actions.delete': 'Eyða',
  'job.info.notes.add.success': 'Athugasemd bætt við',
  'job.info.notes.add.error': 'Athugasemd ekki bætt við, vinsameglast hafið samband við 50skills',
  'job.info.notes.update.success': 'Athugasemd uppfærð',
  'job.info.notes.update.error': 'Athugasemd ekki uppfærð, vinsamlegast hafið samband við 50skills',
  'job.info.notes.remove.confirm': 'Ertu viss um að þú viljir eyða þessari athugasemd?',
  'job.info.notes.remove.success': 'Athugasemd eytt',
  'job.info.notes.remove.error': 'Athugasemd ekki eytt, vinsamlegast hafið samband við 50skills',

  'job.info.files.header': 'Skrár',
  'job.info.files.converttext': 'Vinsamlegast athugið að til að forskoða skrárnar, þá er reynt að breyta þeim í PDF. Þú getur alltaf sótt upprunalegu skránna hér fyrir ofan',
  'job.info.files.empty': 'Engum skrám hefur verið bætt við',
  'job.info.files.download': 'Sækja',
  'job.info.files.remove': 'Eyða',
  'job.info.files.addedby': 'Bætt við af {0}',
  'job.info.files.upload': 'Bæta við skrá',
  'job.info.files.upload.success': 'Skrá bætt við',
  'job.info.files.upload.error': 'Ekki tókst að bæta við skrá. Vinsamlegast hafið samband við 50skills',
  'job.info.files.remove.confirm': 'Ertu viss um að þú viljir eyða þessari skrá?',
  'job.info.files.remove.success': 'Skrá eytt',
  'job.info.files.remove.error': 'Ekki tókst að eyða skrá. Vinsamlegast hafið samband við 50skills',

  'onboarding.applicants.label.name' : 'Nafn',
  'onboarding.applicants.label.hired' : 'Ráðin/n',
  'onboarding.applicants.label.job' : 'Starf',
  'onboarding.applicants.label.status' : 'Onboarding staða',
  'onboarding.applicants.status': '{0} af {1} lokið',
  'onboarding.applicants.status.completed': 'Lokið',
  'onboarding.applicants.status.inprogress': 'Í vinnslu',
  'onboarding.applicants.status.notstarted': 'Ekki hafið',
  'application.label.sourced' : 'Sótt',
  'application.label.notified' : 'Hafnað og tilkynnt',
  'application.label.new' : 'Ný',
  'application.label.manuallyadded' : 'Handvirkt bætt við',
  'job.statistics.bystage': 'Umsækjendur eftir dálki',
  'job.statistics.overview.summary': 'Samanlagt',
  'job.statistics.overview.applicants': 'Fjöldi umsókna',
  'job.statistics.overview.views': 'Heildarfjöldi skoðana',
  'job.statistics.overview.cleared': 'Umsóknir runnar út (GDPR)',
  'job.statistics.overview.status': 'Staða',
  'job.statistics.overview.hired': 'Ráðin/n',
  'job.statistics.overview.active': 'Virk',
  'job.statistics.overview.rejected': 'Hafnað',
  'job.statistics.overview.retracted': 'Dregin til baka',
  'job.statistics.overview.source': 'Uppspretta',
  'job.statistics.overview.direct': 'Beinar',
  'job.statistics.overview.sourced': 'Sótt',
  'job.statistics.overview.manual': 'Handvirkt bætt við',
  'job.statistics.sourcing.heading': 'Virkustu starfsmenn í að finna umsóknir',
  'job.statistics.sourcing.empty': 'Engar umsóknir voru sóttar af starfsmönnum',
  'job.statistics.applicants': 'Umsækjendur',
  'job.statistics.hired': 'Ráðin/n',
  'job.statistics.traffic.heading': 'Uppspretta umsókna',
  'job.statistics.traffic.empty': 'Engar uppsprettur umsókna fundust',
  'job.filters.tip.stages': 'Dálkasýn',
  'job.filters.tip.list': 'Listasýn á umsækjendur',
  'job.filters.tip.search': 'Leita',
  'job.sidebar.title.filters': 'Síur á störf',
  'job.sidebar.title.language': 'Tungumál',
  'job.sidebar.stagefilter.all': 'Allar',
  'job.sidebar.languagefilter.all': 'Allar',
  'job.sidebar.assignedtofilter.anyone': 'Hvern sem er',
  'job.sidebar.assignedtofilter.none': 'Engan',
  'job.sidebar.assignedtofilter.me': 'Mig',
  'job.sidebar.filters.showing': 'Sýni {0} / {1} umsækjendur',
  'job.sidebar.title.show': 'Sýni',
  'job.sidebar.active': 'Virkar',
  'job.sidebar.hired': 'Ráðin/n',
  'job.sidebar.rejected': 'Hafnað',
  'job.sidebar.retracted': 'Dró til baka',
  'job.sidebar.title.labels': 'Merki',
  'job.sidebar.labels.none': 'Engin merki',
  'job.sidebar.labels.manual': 'Handvirkt bætt við',
  'job.sidebar.labels.sourced': 'Sótt af',
  'job.sidebar.labels.rejectionsent': 'Höfnun send',
  'job.sidebar.title.avg': 'Meðaleinkunn',
  'job.sidebar.avg.none': 'Engar umsagnir',
  'job.sidebar.avg.strongy': 'Sterkt já',
  'job.sidebar.avg.yes': 'Já',
  'job.sidebar.avg.no': 'Nei',
  'job.sidebar.avg.defno': 'Sterkt nei',
  'job.sidebar.title.stage': 'Staða',
  'job.sidebar.title.assignment': 'Úthlutað á',
  'job.sidebar.title.byq': 'Eftir svari',
  'job.sidebar.title.job': 'Starf',
  'job.sidebar.title.jobs': 'Störf',
  'job.sidebar.removefilter': 'Hreinsa síur',
  'job.sidebar.chooseq': 'Veldu spurningu',
  'job.sidebar.choosea': 'Veldu svar',
  'modals.grantmulti.heading': 'Gefa aðgang að umsóknum',
  'modals.grantmulti.applicantsmsg': 'Ertu viss um að þú viljir gefa aðgang að eftirfarandi umsóknum:',
  'modals.grantmulti.label': 'Notendur',
  'modals.grantmulti.users.select': 'Veldu notendur til að gefa aðgang að völdum umsóknum',
  'modals.grantmulti.users.empty': 'Engir notendur tiltækir',
  'modals.grantmulti.button.cancel': 'Hætta við',
  'modals.grantmulti.button.submit': 'Gefa aðgang',
  'modals.movetostage.heading': 'Færa í dálk',
  'modals.movetostage.applicantsmsg': 'Ertu viss um að þú viljir færa eftirfarandi umsóknir:',
  'modals.movetostage.stagemsg': 'Í eftirfarandi dálk:',
  'modals.movetostage.stage.select': 'Veldu dálk til að færa umsóknir í',
  'modals.movetostage.button.cancel': 'Hætta við',
  'modals.movetostage.button.submit': 'Færa',
  'job.integrations.button.submit': 'Senda inn',
  'job.integrations.list.title': 'Apps',
  'job.integrations.list.empty': 'Enga samþættingur tiltækar. Ef þú hefur áhuga á að tengja þín kerfi við ráðningarferlið þá hafðu samband við okkur hérna í kerfinu eða í tölvupóst í gegnum info@50skills.com',
  'job.integrations.empty.title': 'Engar samþættingar stilltar',
  'job.integrations.empty.text': 'Ef þú vilt tengja innri samskiptahugbúnað fyrirtækisins t.d. Slack, Facebook Workplace eða annan svipaðan hugbúnað, vinsamlegast hafðu samband við okkur hérna í kerfinu eða í tölvupóst í gegnum info@50skills.com!',
  'job.applications.search.tip': 'Nafn, netfang, sími...',
  'application.onboarding.crumb.onboard' : 'Onboard',
  'application.onboarding.tabs.label' : 'Onboarding val',
  'application.onboarding.tabs.details' : 'Nánari upplýsingar',
  'application.onboarding.tabs.sourcing' : 'Verðlaun',
  'application.onboarding.tip.ssn_only': 'Nafn passar ekki við þjóðskrá ({0}) en kennitala er gild',
  'application.onboarding.tip.keep_or_match': 'Passar ekki við þjóðskrá ({0})',
  'application.onboarding.tip.error': 'Kennitala fannst ekki í þjóðskrá',
  'application.onboarding.applied': 'Sótti um',
  'application.onboarding.label.name': 'Nafn',
  'application.onboarding.label.phone': 'Símanúmer',
  'application.onboarding.label.email': 'Netfang',
  'application.onboarding.label.ssn': 'Kennitala',
  'application.onboarding.verifyssn.keepormatch': 'Nafn passar ekki við upplýsingar úr þjóðskrá: ',
  'application.onboarding.button.keep': 'Halda nafni',
  'application.onboarding.button.match': 'Uppfæra í samræmi við þjóðskrá',
  'application.onboarding.button.verify': 'Staðfesta',
  'application.onboarding.button.again': 'Endurstaðfestu kennitölu',
  'application.onboarding.unverified': 'Staðfestu að þú hafir rétt <span>Nafn</span> og <span>Kennitölu</span> í gegnum þjóðskrá.',
  'application.onboarding.changetemplate.text' : 'Viltu breyta sniðmáti? Núverandi aðgerðarlisti verður fjarlægður.',
  'application.onboarding.removetemplate.text' : 'Viltu fjarlægja núverandi aðgerðarlista?',
  'application.onboarding.tasklist.nocreated' : 'Enginn aðgerðarlisti tiltækur',
  'application.onboarding.tasklist.create' : 'Stofna aðgerðarlista',
  'application.onboarding.tasklist.heading': 'Aðgerðarlisti',
  'application.onboarding.tasklist.choose': 'Veldu sniðmát',
  'application.onboarding.tasklist.remove': 'Fjarlægja aðgerðarlista',
  'application.onboarding.integration.cancel': 'Hætta við',
  'application.onboarding.integration.save': 'Vista',
  'application.onboarding.integration.resend': 'Endursenda',
  'application.onboarding.integration.submit': 'Senda',
  'application.onboarding.integration.delete': 'Eyða',
  'application.onboarding.integration.remove': 'Fjarlægja',
  'application.onboarding.integration.preview': 'Forskoða',
  'application.onboarding.rewards.header': 'Verðlaun',
  'application.onboarding.rewards.norewards': 'Engin verðlaun hafa verið stillt fyrir þetta starf',
  'application.onboarding.rewards.sourcedby': 'Sótt af',
  'application.onboarding.rewards.nosource': 'Enginn sótti þennan starfsmann.',
  'application.onboarding.mark_onboarded': 'Merkja sem onboarded',
  'application.onboarding.unmark_onboarded': 'Afmerkja sem onboarded',
  'application.onboarding.integrations.linked': 'Þessi reitur fær gildi sitt frá {0}',
  'application.onboarding.integrations.linked.application': 'umsókninni',
  'job.recruiters.actions.revoke': 'Fjarlægja aðgang að starfi',
  'job.recruiters.access.isjobfollower': 'Allir umsækjendur',
  'job.recruiters.access.applicants': '{0} umsækjendur',
  'job.recruiters.editaccess.select': 'Veldu þá umsækjendur sem gefa skal aðgang að',
  'job.recruiters.editaccess.noselect': 'Engir umsækjendur tiltækir',
  'job.recruiters.editaccess.noapplicantsselected': 'Engir umsækjendur valdnir.',
  'job.recruiters.editaccess.button.cancel': 'Hætta við',
  'job.recruiters.editaccess.button.submit': 'Vista',
  'job.recruiters.editaccess.heading': 'Breyta aðgangi fyrir umsókn {0}',
  'job.recruiters.editaccess.success': 'Uppfærði aðgang fyrir: {0}',
  'job.recruiters.editaccess.error': 'Ekki tókst að breyta aðgangi hjá: {0}. Vinsamlegast hafið samband við 50skills ef vandamálið leysist ekki.',
  'job.access.limitedaccess.modal.search': 'Nafn, netfang, sími...',
  'job.access.limitedaccess.modal.noemail': 'Ekkert netfang',
  'job.access.limitedaccess.modal.searching': 'Leita að umsækjendum',
  'job.access.limitedaccess.modal.search.nomatch': 'Engir umsækjendur fundust',
  'job.access.limitedaccess.modal.search.noapplicants': 'Ekki fleiri umsækjendur',
  'job.stage.move.error': 'Ekki tókst að breyta röðun dálka. Vinsamlega hafðu samband við 50skills',
  'job.stages.loadingMore': 'Hleð fleirum...',
  'job.stages.menu.sort.title': 'Raða umsóknum eftir',
  'job.stages.menu.sort.name-asc': 'Nafn (Hækkandi) (A til Ö)',
  'job.stages.menu.sort.name-desc': 'Nafn (Lækkandi) (Ö til A)',
  'job.stages.menu.sort.newest': 'Dagsetning umsóknar (Nýjastar fyrst)',
  'job.stages.menu.sort.oldest': 'Dagsetning umsóknar (Elstu fyrst)',
  'job.stages.menu.sort.notes.highest': 'Fjöldi umsagna (Hæstu fyrst)',
  'job.stages.menu.sort.notes.lowest': 'Fjöldi umsagna (Lægstu fyrst)',
  'job.stages.menu.sort.avgvote.highest': 'Meðaleinkunn (Hæstu fyrst)',
  'job.stages.menu.sort.avgvote.lowest': 'Meðaleinkunn (Lægstu fyrst)',
  'job.stages.menu.sort.votecount.highest': 'Fjöldi einkunna (Hæstu fyrst)',
  'job.stages.menu.sort.votecount.lowest': 'Fjöldi einkunna (Lægstu fyrst)',
  'job.stages.menu.title': 'Valmöguleikar',
  'job.stages.menu.applicants': 'Umsækjendur í dálki',
  'job.stages.menu.rename': 'Nefna dálk',
  'job.stages.menu.remove': 'Eyða dálk',
  'job.stages.menu.sort': 'Raða...',
  'job.stages.menu.message': 'Senda skilaboð',
  'job.stages.menu.hire': 'Ráða',
  'job.stages.menu.reject': 'Hafna',
  'job.stages.menu.editname.tip.submit': 'Staðfesta',
  'job.stages.menu.editname.tip.cancel': 'Hætta við',
  'job.stages.menu.def.title': 'Dálkaaðgerðir',
  'job.stages.menu.def.sort': 'Raða umsóknum...',
  'job.stages.menu.def.reject': 'Hafna',
  'job.stages.mobile.displaytext': 'Dálkur: {0}',
  'application.assignee.edit': 'Breyta úthlutun',
  'application.assignee.remove': 'Fjarlægja úthlutun',
  'application.gotoonboarding': 'Onboarding svæði',
  'application.access.addmodal.header': 'Gefa aðgang að stökum umsækjanda',
  'application.access.addmodal.maintext': 'Veittu notendum utan ráðningateymisins aðgang að þessari umsókn. Þeir munu aðeins geta séð þessa umsókn ásamt öðrum sem þeim hefur verið bætt á handvirkt í þessu starfi.',
  'application.access.addmodal.select': 'Veldu notendur til að gefa aðgang',
  'application.access.addmodal.button.cancel': 'Hætta við',
  'application.access.addmodal.button.submit': 'Bæta við',
  'application.gdpr.header': 'Umsókn runnin út',
  'application.gdpr.maintext': 'Vegna reglugerðar ESB um gagnavernd (GDPR) hafa gögn þessa umsækjanda runnið út og hafa þar af leiðandi verið fjarlægð.',
  'application.tabs.label': 'Umsóknarhlutar',
  'application.tabs.details': 'Nánari upplýsingar',
  'application.tabs.contact': 'Tengiliðsupplýsingar',
  'application.tabs.notes': 'Umsagnir',
  'application.tabs.messages': 'Skilaboð',
  'application.tabs.ratings': 'Einkunnir',
  'application.tabs.files': 'Skrár',
  'application.tabs.access': 'Aðgangsmál',
  'application.tabs.attachments': 'Viðhengi',
  'application.tabs.apps': 'Apps',
  'application.tabs.journeys': 'Journeys',
  'application.header.applied': 'Sótti um',
  'application.header.by': 'af {0} / {1}',
  'application.header.answers': 'Umsóknarsvör',
  'application.header.sourced': 'Sótt af',
  'application.header.access': 'Stakir aðgangar',
  'application.header.assignedto': 'Úthlutað á',
  'application.header.files': 'Skrár',
  'application.details.header.applied_to': 'Hefur sótt um • {0} önnur störf',
  'application.details.header.show_all': 'Sýna allt',
  'application.details.header.collapse': 'Fela',
  'application.details.header.cv': 'Ferilskrá',
  'application.details.header.cl': 'Kynningarbréf',
  'application.details.ssnregistry.header': 'Þjóðskrá',
  'application.details.ssnregistry.name': 'Nafn',
  'application.details.ssnregistry.age': 'Aldur',
  'application.details.ssnregistry.ageYearEnd': 'Aldur við lok árs',
  'application.details.ssnregistry.ssn': 'Kennitala',
  'application.details.ssnregistry.gender': 'Kyn',
  'application.details.ssnregistry.postalCode': 'Póstnúmer',
  'application.details.ssnregistry.city': 'Borg / Bær',
  'application.details.ssnregistry.street': 'Gata',
  'application.details.ssnregistry.no_details': 'Engar upplýsingar',
  'application.details.nocvpreview': 'Ekki tókst að forsýna ferilskrá',
  'application.details.noclpreview': 'Ekki tókst að forsýna kynningarbréf',
  'application.details.nocvuploaded': 'Engin ferilskrá var send inn með umsókn',
  'application.details.nocluploaded': 'Ekkert kynningarbréf var sent inn með umsókn',
  'application.details.noanswer': '(Ekkert svar gefið)',
  'application.details.deletedquestion': '(Spurning fjarlægð af starfi)',
  'application.details.deletedoption': '(Valkostur fjarlægður úr spurningu)',
  'application.details.attachtip': 'Smelltu til að skoða skrá',
  'application.attachment.nopreview': 'Ekki tókst að forsýna viðhengi',
  'application.attachment.download': 'Hala niður',
  'application.attachments.add.success': 'Skrá hefur verið bætt við',
  'application.attachments.add.error': 'Ekki tókst að bæta við nýrri skrá',
  'application.attachments.remove.success': 'Skrá hefur verið fjarlægð',
  'application.attachments.remove.error': 'Ekki tókst að fjarlægja skrá',
  'application.clicktodownload': 'Smelltu til að niðurhala skrá',
  'application.list.allstages': 'Allir dálkar',
  'application.list.cardlistname': 'Umsækjendur',
  'application.access.header': 'Ráðningarteymi',
  'application.access.roleheader': 'Hlutverk',
  'application.access.revoke': 'Fjarlægja',
  'application.access.revoking': 'Fjarlægi aðgang...',
  'application.access.noaccess': 'Umsækjandi er ekki sýnilegur af neinum utan ráðningateymisins',
  'application.access.button.submit': 'Veita aðgang',
  'application.header.contact': 'Tengiliðsupplýsingar',
  'application.contact.name': 'Fullt nafn',
  'application.contact.email': 'Netfang',
  'application.contact.phone': 'Símanúmer',
  'application.contact.ssn': 'Kennitala',
  'application.header.social': 'Samfélagsmiðlaprófíll',
  'application.contact.link': 'Hlekkur',
  'application.contact.nocontent': 'Þessu umsækjandi bætti ekki við neinum samfélagsmiðlum',

  'application.messages.header': 'Skilaboð',
  'application.messages.textbox.button.submit': 'Senda skilaboð',
  'application.messages.disabled.card': 'Notendur með takmarkaðan aðgang geta ekki sent skilaboð beint á umsækjendur',
  'application.messages.send.success': 'Skilaboð send',
  'application.messages.send.error': 'Ekki tókst að senda skilaboð',
  'application.messages.editor.placeholder': 'Senda skilaboð á umsækjandann í tölvupósti',
  'application.messages.footer.rejection': 'Hafna',
  'application.messages.footer.application': 'Umsókn',
  'application.messages.confirm': 'Eftirfarandi skilaboð verða send í tölvupósti á umsækjandann {0}:',
  'application.messages.send': 'Senda skilaboð',
  'application.messages.error': 'Villa',
  'application.messages.deliveryfailure': 'Villa við að senda póst',

  'application.notes.actions.edit': 'Breyta',
  'application.notes.actions.delete': 'Eyða',
  'application.notes.header': 'Umsagnir teymis',
  'application.reviews.nocontent': 'Þessi umsækjandi hefur engar umsagnir frá þínu teymi',
  'application.reviews.header.you': 'Þínar einkunnir',
  'application.reviews.header.team': 'Einkunnir teymis',
  'application.reviews.average': 'Meðaleinkunn: {0}',
  'application.notes.edit.button.cancel': 'Hætta við',
  'application.notes.edit.button.submit': 'Uppfæra',
  'application.notes.textbox.button.submit': 'Vista umsögn',
  'application.notes.textbox.admin_note.label': 'Stjórnenda umsögn',
  'application.notes.textbox.switch.admin': 'Stjórnenda umsögn',
  'application.notes.textbox.info': 'Stjórnenda umsögn er aðeins sýnileg stjórnendum',
  'application.notes.adminonly': 'Aðeins sýnilegt stjórnendum',
  'application.notes.textbox.button.submit.regular': 'Vista umsögn',
  'application.notes.textbox.button.submit.admin': 'Vista stjórnenda umsögn',
  'application.notes.textbox.placeholder.regular': 'Bæta við umsögn eða notaðu @ merkið til að láta samstarfsmenn þína vita.',
  'application.notes.textbox.placeholder.admin': 'Bæta við stjórnenda umsögn á umsókn - Aðeins stjórnendur sjá þessar umsagnir',

  'application.removeconfirm.header': 'Staðfesta eyðingu',
  'application.removeconfirm.confirm': 'Ertu viss um að þú viljir eyða umsókn {0}?',
  'application.removeconfirm.warning': 'Þessi aðgerð er óafturkræf!',
  'application.removeconfirm.button.cancel': 'Hætta við',
  'application.removeconfirm.button.submit': 'Staðfesta',
  'application.rating.no': 'Nei',
  'application.rating.defno': 'Sterkt nei',
  'application.rating.yes': 'Já',
  'application.rating.strongyes': 'Sterkt já',
  'application.files.add': 'Bæta við skrá',
  'application.files.attached': 'Bætt við af',
  'application.files.remove': 'Fjarlægja viðhengi',
  'application.files.nofiles': 'Engin viðhengi skráð',
  'application.files.download': 'Niðurhala skrá',
  'application.files.hoveropen': 'Smelltu til að skoða skrá',
  'application.files.nopreview': 'Ekki tókst að forsýna skrá',
  'application.files.supportedformats': 'Leyfilegar skrár: pdf, doc, docx, xls, xlsx, png, jpg, jpeg, gif, bmp, heic. Vinsamlegast athugaðu: þú getur enn reynt að hlaða niður skránni og opnað hana á tölvunni þinni.',
  'application.files.converttext': 'Vinsamlegast athugið að til að forskoða skrárnar, þá er reynt að breyta þeim í PDF. Þú getur alltaf sótt upprunalegu skránna hér fyrir ofan.',
  'application.move.success': 'Umsókn fyrir {0} færð til {1}',
  'application.move.error': 'Ekki tókst að færa {0} til {1}. Vinsamlegast hafið samband við 50skills.',
  'application.copy.success': 'Umsókn fyrir {0} afrituð til {1}',
  'application.copy.error': 'Ekki tókst að afrita {0} til {1}. Vinsamlegast hafið samband við 50skills.',
  'application.copy.title': 'Afrita umsókn til',
  'application.move.title': 'Færa umsókn til',
  'application.movecopy.modal.label.application': 'Umsækjandi',
  'application.movecopy.modal.label.job': 'Starfstitill',
  'application.movecopy.modal.follow': 'Opna umsókn',
  'application.movecopy.modal.follow.copy': 'Opna afrit',
  'application.movecopy.modal.back': 'Loka',
  'application.movecopy.modal.copy.title': 'Umsókn afrituð',
  'application.movecopy.modal.move.title': 'Umsókn færð',
  'application.movecopy.loadingjobs': 'Hleð störf...',
  'application.movecopy.selectjob': 'Velja starf',
  'application.movecopy.selectjob.searching': 'Leita að störfum 🕵️',
  'application.movecopy.selectjob.nomatch': 'Engin störf fundin fyrir {0}',
  'application.movecopy.selectjob.nojobs': 'Engin virk störf',
  'application.movecopy.selectstage': 'Velja dálk',
  'application.movecopy.label.company': 'Fyrirtæki',
  'application.movecopy.label.job': 'Starf',
  'application.movecopy.label.stage': 'Dálkur',
  'application.movecopy.label.include': 'Innihalda gögn',
  'application.movecopy.label.coverletter': 'Kynningarbréf',
  'application.movecopy.label.notes': 'Umsagnir',
  'application.movecopy.label.files': 'Skrár',
  'application.movecopy.label.responses': 'Svör við spurningum',
  'application.movecopy.label.ratings': 'Einkunnir',
  'application.movecopy.responses.message': 'Þú munt verða beðin/n um að para saman spurningar milli starfanna í næsta skrefi.',
  'application.movecopy.warning.message': 'Allt sem er ekki hakað við mun tapast, þetta er óafturkræf aðgerð.',
  'application.movecopy.button.cancel': 'Hætta við',
  'application.movecopy.button.cont': 'Áfram',
  'application.movecopy.current.resp': 'Núverandi svör',
  'application.movecopy.new.resp': 'Ný svör',
  'application.movecopy.button.back': 'Til baka',
  'application.movecopy.button.move': 'Færa',
  'application.movecopy.button.copy': 'Afrita',
  'application.movecopy.addfile': 'Smelltu til að bæta við skrá',
  'application.movecopy.addresp': 'Smelltu til að bæta við svari',
  'application.confirmcopy.title': 'Ertu viss?',
  'application.confirmcopy.main': 'Allt sem er ekki við hakað mun tapast. Þú hefur valið að taka ekki með {0}',
  'application.confirmcopy.warn': 'Þessi aðgerð er óafturkræf.',
  'application.confirmcopy.cta': 'Viltu halda áfram?',
  'application.confirmcopy.back': 'Nei, fara til baka!',
  'application.confirmcopy.proc': 'Áfram',
  'showmore': 'Sýna meira',
  'companies.switchTo': 'Skipta í fyrirtæki: {0}',
  'companies.successfulSwitch': 'Skipting yfir í fyrirtæki: {0} tókst',

  // Common integration text
  'integrations.common.settings.connected': 'Tengt',
  'integrations.common.settings.notconnected': 'Ekki tengt',
  'integrations.common.settings.disconnect': 'Aftengja',
  'integrations.common.settings.withthis': 'Með þessari tengingu getur þú:',

  // AD Manager
  'integrations.admanager.title': 'AD Manager',
  'integrations.admanager.description': 'Stofna AD notendanöfn fyrir umsækjendur',
  'integrations.admanager.settings.withthis.create': 'Stofnað notendur í AD',
  'integrations.admanager.settings.helptext': 'Vinsamlegast fylltu út formið fyrir neðan og smelltu á Staðfesta.',
  'integrations.admanager.settings.authtoken': 'Auth Token',
  'integrations.admanager.settings.baseurl': 'Base URL',
  'integrations.admanager.settings.domainname': 'Domain Name',
  'integrations.admanager.settings.templates.title': 'Sniðmát',
  'integrations.admanager.settings.templates.none.header': 'Engin sniðmát',
  'integrations.admanager.settings.templates.none.content': 'Bættu við sniðmátum með því að smella á + hér að ofan',
  'integrations.admanager.settings.templates.header': 'Nýtt sniðmát',
  'integrations.admanager.settings.templates.label': 'Nafn sniðmáts',
  'integrations.admanager.settings.templates.button.submit': 'Bæta við',
  'integrations.admanager.settings.templates.add.success': 'Sniðmáti bætt við',
  'integrations.admanager.settings.templates.add.error': 'Ekki tókst að bæta við sniðmáti',
  'integrations.admanager.settings.templates.delete': 'Eyða',
  'integrations.admanager.settings.templates.remove.success': 'Sniðmáti eytt',
  'integrations.admanager.settings.save.success': 'Stillingar vistaðar',
  'integrations.admanager.settings.save.error': 'Ekki tókst að vista stillingar, ertu viss um að útfylltir reitir séu réttir?',
  'integrations.admanager.settings.disconnect.success': 'AD Manager aftengt',
  'integrations.admanager.settings.disconnect.error': 'Ekki tókst að aftengja AD Manager',
  'integrations.admanager.job.notconnected': 'Tenging ekki virk, vinsamlegast farðu í fyrirtækjastillingar eða biddu um aðstoð frá stjórnanda',
  'integrations.admanager.job.templates.label': 'Sniðmát',
  'integrations.admanager.job.save.success': 'Sniðmát vistað á starf',
  'integrations.admanager.job.save.error': 'Ekki tókst að vista sniðmát á starf',
  'integrations.admanager.job.remove.success': 'Sniðmát fjarlægt af starfi',
  'integrations.admanager.job.remove.error': 'Ekki tókst að fjarlægja sniðmát af starfi',
  'integrations.admanager.application.button.create': 'Stofna í AD',
  'integrations.admanager.application.create.success': 'User created in AD',
  'integrations.admanager.application.create.error': 'Unable to create user in AD',
  'integrations.admanager.application.notcreated': 'Ekki stofnaður í AD',
  'integrations.admanager.application.username.label': 'AD Notendanafn',
  'integrations.admanager.application.generatedby.label': 'Stofnað af',
  'integrations.admanager.applications.create.success': 'Byrjað að stofna notendur í AD',
  'integrations.admanager.applications.create.error': 'Ekki tókst að stofna notendur í AD',
  'integrations.admanager.modal.header': 'Stofna notanda í AD',
  'integrations.admanager.modal.template.label': 'Nafn sniðmáts',
  'integrations.admanager.modal.button.submit': 'Stofna notanda',
  'integrations.admanager.bulkmodal.header': 'Stofna notendur í AD',
  'integrations.admanager.bulkmodal.note': 'Athugið að þetta gæti tekið einhverjar mínútur',
  'integrations.admanager.bulkmodal.button.submit': 'Stofna notendur',
  'integrations.admanager.filters.created': 'Stofnað í AD',
  'integrations.admanager.filters.notcreated': 'Ekki stofnað í AD',
  'integrations.admanager.filters.applied.created': 'Stofnað',
  'integrations.admanager.bulk.send': 'Stofna notendur',
  'integrations.admanager.labels.created': 'AD Manager: Stofnað',
  
  // OneCRM
  'integrations.onecrm.applicants.retry.success': 'Umsóknarmál hefur verið stofnað í OneCRM',
  'integrations.onecrm.applicants.retry.fail': 'Ekki tókst að stofna umsóknarmál í OneCRM',
  'integrations.onecrm.applicants.retry.button': 'Endursenda',
  'integrations.onecrm.applicants.confirm.button': 'Senda',
  'integrations.onecrm.applicants.confirm.header': 'Senda í OneCRM',
  'integrations.onecrm.applicants.confirm.main': 'Þú ert að fara að senda {0} umsóknir yfir í OneCRM.',
  'integrations.onecrm.data_to_be_sent': 'Gögn sem verða send í OneCRM',
  'integrations.onecrm.job.applicants.cover': 'Kynningarbréf',
  'integrations.onecrm.job.applicants.created': 'Stofnað af',
  'integrations.onecrm.job.applicants.cv': 'Ferilskrá',
  'integrations.onecrm.job.applicants.files': 'Skrár',
  'integrations.onecrm.job.applicants.header': 'Umsóknamál',
  'integrations.onecrm.job.applicants.msg': 'Skilaboð',
  'integrations.onecrm.job.applicants.qa': 'Spurningar og svör',
  'integrations.onecrm.job.applicants.send': 'Senda í OneCRM',
  'integrations.onecrm.job.applicants.transfercomplete': 'Umsóknamál stofnuð',
  'integrations.onecrm.job.applicants.transfering': 'Stofna umsóknamál',
  'integrations.onecrm.job.header': 'Stofna starfsmál og umsóknamál í OneCRM',
  'integrations.onecrm.jobcase.create.error': 'Ekki tókst að stofna móðurmál starfs í OneCRM.',
  'integrations.onecrm.jobcase.create.submit': 'Stofna starfsmál',
  'integrations.onecrm.jobcase.create.success': 'Móðurmál starfs stofnað í OneCRM',
  'integrations.onecrm.jobcase.createdby': 'Stofnað af',
  'integrations.onecrm.jobcase.files': 'Skrár',
  'integrations.onecrm.jobcase.header': 'Starfsmál',
  'integrations.onecrm.jobcase.info': 'Starfsupplýsingar',
  'integrations.onecrm.jobcase.manager': 'Ábyrgðaraðili',
  'integrations.onecrm.jobcase.notes': 'Athugasemdir',
  'integrations.onecrm.jobcase.title': 'Titill',
  'integrations.onecrm.onboarding.create.action': 'Stofna mál',
  'integrations.onecrm.onboarding.create.error': 'Ekki tókst að stofna ráðningarmál í OneCRM.',
  'integrations.onecrm.onboarding.create.label': 'Gögn sem verða send í OneCRM',
  'integrations.onecrm.onboarding.create.success': 'Ráðningarmál stofnað',
  'integrations.onecrm.onboarding.create.title': 'Ráðningarmál',
  'integrations.onecrm.onboarding.gojobapp': 'Opna starfs appið',
  'integrations.onecrm.onboarding.jobcase.createdby': 'Stofnað af',
  'integrations.onecrm.onboarding.jobcase.header': 'Starfsmál',
  'integrations.onecrm.onboarding.jobcase.manager': 'Ábyrgðaraðili',
  'integrations.onecrm.onboarding.jobcase.title': 'Titill',
  'integrations.onecrm.onboarding.nojobcase': 'Ekkert móðurmál fannst fyrir þetta starf. Stofna þarf móðurmál áður en hægt er að stofna ráðningarmál. Færðu þig yfir á Apps undirsíðuna og stofnaðu móðurmál og reyndu aftur.',
  'integrations.onecrm.onboarding.title': 'Stofna ráðningarmál í OneCRM',
  'integrations.onecrm.settings.applicationTemplate': 'Sniðmát umsóknarmáls',
  'integrations.onecrm.settings.connect': 'Tengja',
  'integrations.onecrm.settings.create.error': 'Ekki tókst að tengja við OneCRM.',
  'integrations.onecrm.settings.create.success': 'Tenging við OneCRM tókst.',
  'integrations.onecrm.settings.idNumber': 'Kennitala fyrirtækis í OneCRM',
  'integrations.onecrm.settings.jobTemplate': 'Sniðmát móðurmáls',
  'integrations.onecrm.settings.onboardingTemplate': 'Sniðmát ráðningarmáls',
  'integrations.onecrm.settings.password': 'Lykilorð',
  'integrations.onecrm.settings.save': 'Vista',
  'integrations.onecrm.settings.update.error': 'Ekki tókst að uppfæra OneCRM stillingar.',
  'integrations.onecrm.settings.update.success': 'Stillingar fyrir OneCRM tengingu voru uppfærðar.',
  'integrations.onecrm.settings.url': 'Slóð á OneCRM vefþjónustu',
  'integrations.onecrm.settings.username': 'Notandanafn',
  'integrations.onecrm.transfer.e': 'Villa',
  'integrations.onecrm.transfer.n': 'Engin skrá fannst',
  'integrations.onecrm.transfer.p': 'Í vinnslu',
  'integrations.onecrm.transfer.s': 'Sent',

  // GetAccept
  'integrations.getaccept.settings.noauth': 'Velkomin(n) ⚡️. Það lítur út fyrir að þú hafir ekki tengt GetAccept aðganging þinn við 50skills! Ef þú smellir á takkann fyrir neðan, þá ferðu á síðu hjá GetAccept þar sem þú getur tengst saman vinina tvo 🧑‍💻👩‍💻 Við hinkrum eftir þér!',
  'integrations.getaccept.settings.auth.button': 'Tengjast',
  'integrations.getaccept.settings.template.save.success': 'Sniðmát vistað',
  'integrations.getaccept.settings.template.save.error': 'Sniðmát ekki vistað, vinsamlegast hafðu samband við 50skills',
  'integrations.getaccept.settings.templates.submit': 'Vista',
  'integrations.getaccept.settings.authed': 'Vel gert 🚀! Fylgdu bara leiðbeiningunum hér fyrir neðan og þú munt vera farin(n) að skrifa undir samning áður en þú veist af',
  'integrations.getaccept.settings.header': 'GetAccept',
  'integrations.getaccept.settings.header.settings': 'Stillingar',
  'integrations.getaccept.settings.needsapproval.label': 'Þarfnast samþykktar',
  'integrations.getaccept.settings.needsapprovallabel.label': 'Nafn samþykktarreits',
  'integrations.getaccept.settings.needsapproval.error': 'Nafn samþykktarreits er skilyrt þegar þarfnast samþykktar er valið',
  'integrations.getaccept.settings.save': 'Vista stillingar',
  'integrations.getaccept.settings.save.success': 'Stillingar vistaðar',
  'integrations.getaccept.settings.instructions.settings': 'Ef þú vilt að notandi samþykki hvern samning áður en umsækjandi fær hann, fylltu þá út formið hér fyrir neðan',
  'integrations.getaccept.settings.header.templates': 'Sniðmát',
  'integrations.getaccept.settings.instructions.templates': 'Veldu sniðmót hér að neðan til að sérsníða það',
  'integrations.getaccept.settings.instructions.notemplate': 'Obbosí, engin sniðmát fundust 👀. Skelltu þér á GetAccept síðuna og búðu til fyrsta sniðmátið þitt! Við hinkum eftir þér ⏰',
  'integrations.getaccept.settings.subheader': 'Reitir',
  'integrations.getaccept.settings.fields.instructions': 'Hér fyrir neðan eru listi af reitum sem sniðmátið inniheldur, hérna getur þú kortlagt gildi frá öðrum öppum eða frá umsókninni sjálfri. Engar áhyggjur, notandinn getur alltaf breytt gildunum seinna 🚀',
  'integrations.getaccept.settings.fields.instructions.nofields': 'Það lítur út fyrir að þeteta sniðmát inniheldur enga reiti 🤷‍♀️. Kannski var það ætlunin, en ef ekki, skelltu þér bara á síðuna hjá GetAccept og bættum við nokkrum reitum. Við verðum hér þegar þú ert búin(n) 📝',
  'integrations.getaccept.settings.fields.clear': 'hreinsa',

  // Onboarding Form
  'integrations.onboardingform.settings.header': 'Innleiðingarform',
  'integrations.onboardingform.settings.sms': 'SMS skilaboð',
  'integrations.onboardingform.settings.sms.instructions': 'Senda SMS tilkynningu og upplýsingaskilaboð til umsækjenda þegar þú sendir þeim innleiðingarformið.',
  'integrations.onboardingform.settings.sms.tag': 'Auka',
  'integrations.onboardingform.settings.disabled': 'Óvirkt',
  'integrations.onboardingform.settings.enable': 'Virkja',
  'integrations.onboardingform.settings.enabled': 'Virkt',
  'integrations.onboardingform.settings.sms.menu.edit': 'Breyta skilaboðum',
  'integrations.onboardingform.settings.sms.menu.disable': 'Óvirkja sms skilaboð',
  'integrations.onboardingform.settings.sms.disable.toast': 'Sms skilaboð óvirkt',
  'integrations.onboardingform.settings.sms.template.empty': 'SMS sniðmát má ekki vera tómt',
  'integrations.onboardingform.settings.sms.template.characters': '/320 stafir notaðir',
  'integrations.onboardingform.settings.email': 'Tilkynningarpóstur þegar innleiðingarformi er lokið',
  'integrations.onboardingform.settings.email.instructions': 'Senda tilkynningapóst á eftirfarandi netföng sem eiga að fá tilkynningu þegar umsækjendur hafa fyllt út innleiðingarform. \nÞeir notendur sem senda út formin fá alltaf þessa tilkynningu.',
  'integrations.onboardingform.settings.email.recipients': 'Viðtakendur:',
  'integrations.onboardingform.settings.email.applicant': 'Umsækjenda tilkynningarpóstur þegar innleiðingarformi er lokið',
  'integrations.onboardingform.settings.email.applicant.instructions': 'Senda tilkynningarpóst til umsækjenda þegar þeir hafa fyllt út innleiðingarformið.',
  'integrations.onboardingform.settings.email.card.header': 'Tölvupóstur',
  'integrations.onboardingform.settings.email.menu.edit': 'Breyta tölvupósti',
  'integrations.onboardingform.settings.email.menu.disable': 'Óvirkja tölvupóst',
  'integrations.onboardingform.settings.email.get-templates.error': 'Ekki tókst að sækja sniðmát',
  'integrations.onboardingform.settings.email.create.success': 'Tilkynningarpóstur búinn til',
  'integrations.onboardingform.settings.email.update.success': 'Tilkynningarpóstur uppfærður',
  'integrations.onboardingform.settings.email.disable.success': 'Tilkynningarpóstur óvirkur',
  'integrations.onboardingform.settings.email.disable.error': 'Ekki tókst að óvirkja tilkynningarpóst',
  'integrations.onboardingform.settings.email.disable.modal.header': 'Slökkva á tilkynningarpósti',
  'integrations.onboardingform.settings.email.disable.modal.body': 'Notendur sem senda út form munu ekki lengur fá tilkynningarpóst og viðtakendum verður eytt. \nErtu viss um að þú viljir halda áfram?',
  'integrations.onboardingform.settings.email.disable.modal.disable': 'Óvirkja',
  'integrations.onboardingform.settings.completion-email.modal.title': 'Tilkynningarpóstur',
  'integrations.onboardingform.settings.completion-email.modal.title.edit': 'Breyta tilkynningarpósti',
  'integrations.onboardingform.settings.completion-email.modal.description': 'Sérsníddu tölvupóstinn sem sendur er á alla viðtakendur þegar umsækjendur hafa fyllt út innleiðingarformið.',
  'integrations.onboardingform.settings.completion-email.applicant.modal.title': 'Umsækjenda tilkynningarpóstur',
  'integrations.onboardingform.settings.completion-email.applicant.modal.title.edit': 'Breyta umsækjenda tilkynningarpósti',
  'integrations.onboardingform.settings.completion-email.applicant.modal.description': 'Sérsníddu tölvupóstinn sem sendur er til umsækjenda þegar þeir hafa fyllt út innleiðingarformið.',
  'integrations.onboardingform.settings.completion-email.modal.emailsubject': 'Efni tölvupósts',
  'integrations.onboardingform.settings.completion-email.modal.emailsubject.error': 'Efni vantar',
  'integrations.onboardingform.settings.completion-email.modal.emailbody': 'Meginmál',
  'integrations.onboardingform.settings.completion-email.modal.emailbody.error': 'Meginmál vantar',
  'integrations.onboardingform.settings.emails.error': 'Ógilt netfang',
  'integrations.onboardingform.settings.submit': 'Bæta við viðtakanda',
  'integrations.onboardingform.settings.email.edit': 'Breyta',
  'integrations.onboardingform.settings.email.remove': 'Fjarlægja viðtakanda',
  'integrations.onboardingform.settings.emails.remove.success': 'Viðtakandi fjarlægður',
  'integrations.onboardingform.settings.save.success': 'App vistað',
  'integrations.onboardingform.settings.save.error': 'App ekki vistað, vinsamlegast hafðu samband við 50skills',
  'integrations.onboardingform.settings.add.modal.title': 'Bæta við viðtakanda',
  'integrations.onboardingform.settings.add.modal.name': 'Nafn',
  'integrations.onboardingform.settings.add.modal.email': 'Netfang',
  'integrations.onboardingform.settings.add.modal.recipient.added.toast': 'Viðtakanda bætt við',
  'integrations.onboardingform.settings.add.modal.name.missing': 'Nafn vantar',
  'integrations.onboardingform.settings.edit.modal.title': 'Breyta viðtakanda',
  'integrations.onboardingform.settings.edit.modal.recipient.changed.toast': 'Viðtakanda breytt',
  'integrations.onboardingform.bulk.send': 'Senda innleiðingarform',
  'integrations.onboardingform.bulk.modal.info': 'Vinsamlegast athugið að einungis umsóknir sem hafa ekki nú þegar fengið innleiðingarform eru gildar í þessa aðgerð',
  'integrations.onboardingform.bulk.modal.noapplicants': 'Engar gildar umsóknir hafa verið valdnar. Vinsamlegast athugið að einungis umsóknir sem hafa verið merktar ráðnar og hafa ekki nú þegar fengið innleiðingarform eru gildar í þessa aðgerð',
  'integrations.onboardingform.bulk.modal.header': 'Senda innleiðingarform',
  'integrations.onboardingform.bulk.modal.send.header': 'Senda innleiðingarform til umsækjenda',
  'integrations.onboardingform.bulk.modal.sent.header': 'Sendi',
  'integrations.onboardingform.bulk.modal.sent.text': 'Verið er að framkvæma aðgerðina. Athugið að þetta gæti tekið nokkrar mínútur',
  'integrations.onboardingform.bulk.modal.send.error': 'Eitthvað fór úrskeiðis, vinsamlegast hafðu samband við 50skills',
  'integrations.onboardingform.bulk.modal.templates.label': 'Veldu sniðmát',
  'integrations.onboardingform.bulk.modal.submit': 'Senda innleiðingarform',
  'integrations.onboardingform.sms.modal.subheader': 'Sérsníddu SMS skilaboðin sem þú vilt senda umsækjendum. Notaðu {{url}} fyrir hlekk á innleiðingarformið.',
  'integrations.onboardingform.sms.modal.label': 'Skilaboð',
  'integrations.onboardingform.sms.modal.helptext': 'Heppileg lengd á skilaboðum eru 320 stafir eða færri',
  'integrations.onboardingform.sms.modal.initialtext': 'Góðan daginn, við höfum sent þér innleiðingarform fyrir nýtt starfsfólk til að fylla út, <br>endilega heimsæktu {{url}} til að byrja innleiðingarferlið þitt. <br>Við höfum einnig sent þér hlekkinn í tölvupósti. <br>Bestu kveðjur',
  'integrations.onboardingform.sms.modal.cancel': 'Hætta við',
  'integrations.onboardingform.sms.modal.save': 'Vista',
  'integrations.onboardingform.sms.modal.save.toast': 'SMS skilaboð vistuð',
  'integrations.onboardingform.sms.modal.messagelong': 'SMS skilaboð of langt',
  'integrations.onboardingform.form.template.label': 'Veldu sniðmát',
  'integrations.onboardingform.form.email': 'Netfang',
  'integrations.onboardingform.form.sendsms': 'Senda SMS skilaboð',
  'integrations.onboardingform.form.datesent': 'Dagsetning sent',
  'integrations.onboardingform.form.dateCompleted': 'Dagsetning lokið',
  'integrations.onboardingform.form.sentto.mail': 'Sent til • Netfang',
  'integrations.onboardingform.form.sentto.sms': 'Sent til • SMS',
  'integrations.onboardingform.form.sentby': 'Sent af',
  'integrations.onboardingform.form.inprogress': 'Í vinnslu',
  'integrations.onboardingform.form.completed': 'Lokið',
  'integrations.onboardingform.form.resend': 'Endursenda',
  'integrations.onboardingform.form.answer.missing': 'Ekkert svar gefið',
  'integrations.onboardingform.form.tooltip.remove': 'Fjarlægja form',
  'integrations.onboardingform.form.tooltip.copylink': 'Afrita hlekk',
  'integrations.onboardingform.form.tooltip.resend': 'Endursenda form',
  'integrations.onboardingform.form.copied.toast': 'Hlekkur afritaður',
  'integrations.onboardingform.form.sent.toast': 'Innleiðingarform sent',
  'integrations.onboardingform.form.error.toast': 'Onboarding form villa. Vinsamlegast hafið samband við 50skills.',
  'integrations.onboardingform.form.error.email.invalid': 'Ógilt netfang',
  'integrations.onboardingform.form.error.phone.missing': 'Símanúmer vantar, afhakaðu við "Senda SMS" eða bættu við símanúmeri',
  'integrations.onboardingform.form.error.template.missing': 'Sniðmát vantar',
  'integrations.onboardingform.resend.modal.header': 'Endursenda innleiðingarform',
  'integrations.onboardingform.save.no.phone.error': 'Símanúmers reitur má ekki vera tómur ef búið er að haka í Senda SMS skilaboð',
  'integrations.onboardingform.template.none': 'Engin sniðmát fáanleg',
  'integrations.onboardingform.integrationHeader.title': 'Onboarding form',
  'integrations.onboardingform.integrationHeader.description': 'Senda nýjum starfsmanni onboarding form',

  // Onboarding Form RU
  "integrations.ru.onboardingform.add.signee": "Bæta við öðrum undirskrifanda",
  "integrations.ru.onboardingform.register.to.union": "Skrá starfsmann í starfsmannafélag",
  "integrations.ru.onboardingform.send.to.esigning": "Senda samning í undirritun með rafrænum skilríkjum",
  "integrations.ru.onboardingform.signee.email": "Netfang undirskrifanda (HR)",
  "integrations.ru.onboardingform.signee.name": "Undirskrifandi fyrir hönd HR",
  "integrations.ru.onboardingform.signee.phone": "Símanúmer undirskrifanda",
  "integrations.ru.onboardingform.signee.ssn": "Kennitala undirskrifanda (HR)",

  // Kjarni
  'integrations.kjarni.settings.header': 'Kjarni',
  'integrations.kjarni.settings.instructions': 'Velkomin/n ⚡️. Hér getur þú bætt við netföngum hjá aðilum sem eiga alltaf að fá tilkynningar þegar form hefur verið fyllt út.',
  'integrations.kjarni.settings.emails.label': 'Netföng',
  'integrations.kjarni.settings.emails.error': 'Ógilt netfang',
  'integrations.kjarni.settings.submit': 'Vista',
  'integrations.kjarni.settings.save.success': 'App vistað',
  'integrations.kjarni.settings.save.error': 'App ekki vistað, vinsamlegast hafðu samband við 50skills',

  // Asana
  'integrations.asana.settings.header': 'Asana',
  'integrations.asana.settings.header.token': 'Token set',
  'integrations.asana.settings.header.notoken': 'Token not set',
  'integrations.asana.settings.instructions.header.sub': 'Ef þú vilt nota Asana fyrir virkjun starfsmanna (e. onboarding), getur þú mælt hversu margar aðgerðir hafa verið kláraðar í Asana innan 50skills og séð í samhengi við aðrar aðgerðir sem snýr að ráðningu starfsmanns.',
  'integrations.asana.settings.instructions.step1.header': 'Tenging á milli 50skills og Asana',
  'integrations.asana.settings.instructions.step1.sub_header': 'A) Stofnaðu nýjan notanda í Asana með nafninu 50skills',
  'integrations.asana.settings.instructions.step1': 'Þessi notandi stofnar ný verkefni (e. projects), þannig passaðu að þessi notandi hafi aðgang að öllum teymum sem snúa að virkjun starfsmanna (e. onboarding).',
  'integrations.asana.settings.instructions.step2.sub_header': 'B) Skráðu þig inn sem sá notandi',
  'integrations.asana.settings.instructions.step2.1': 'Farðu í My Profile Settings > Apps > Manage Developer Apps eða farðu á ',
  'integrations.asana.settings.instructions.step2.2': 'Undir “Personal access tokens” - smelltu á “New access token”.',
  'integrations.asana.settings.instructions.step2.3': 'Nefndu auðkennið (e. token) 50skills og lestu og samþykktu skilmála.',
  'integrations.asana.settings.instructions.step3.sub_header': 'C) Bættu auðkenni við 50skills',
  'integrations.asana.settings.instructions.step3': 'Afritaðu auðkennið og límdu það á svæðið fyrir ofan merkt “Token” og vistaðu. 50skills felur í kjölfarið auðkennið.',
  'integrations.asana.settings.token.label': 'Token',
  'integrations.asana.settings.submit': 'Vista',
  'integrations.asana.settings.save.success': 'App vistað',
  'integrations.asana.settings.save.error': 'App ekki vistað, vinsamlegast hafðu samband við 50skills',

  // HR Monitor
  'integrations.hrmonitor.settings.header': 'HR Monitor',
  'integrations.hrmonitor.settings.header.connected': 'Tengt',
  'integrations.hrmonitor.settings.header.notconnected': 'Ekki tengt',
  'integrations.hrmonitor.settings.info': 'Listen, measure and bring out the best in your people',
  'integrations.hrmonitor.settings.connect': 'Tengja',
  'integrations.hrmonitor.settings.save.success': 'App tengt',
  'integrations.hrmonitor.settings.save.error': 'App ekki tengt, vinsamlegast hafðu samband við 50skills',

  // Relesys
  'integrations.relesys.settings.header': 'Relesys',
  'integrations.relesys.settings.header.clientsecret': 'Tengt',
  'integrations.relesys.settings.header.noclientsecret': 'Ekki tengt',
  'integrations.relesys.settings.instructions.header': 'Introduction',
  'integrations.relesys.settings.instructions.content': 'Þú getur tengt 50skills og Relesys til að einfalda hvernig nýir umsækjendur eru stofnaðir í Relesys.',
  'integrations.relesys.settings.gettingaccess.header': 'Fá aðgang að Relesys API',
  'integrations.relesys.settings.gettingaccess.content': 'Til að fá aðgang að Relesys API þarft þú að sækja “Client ID” og “Client Secret” frá Relesys. Til að gera þetta þarft þú að hafa samband við þinn tengilið hjá Relesys eða með því að senda tölvupóst á support@relesys.net fyrir frekari aðstoð.',
  'integrations.relesys.settings.howtoconnect.header': 'Hvernig á að koma á tengingu við Relesys',
  'integrations.relesys.settings.howtoconnect.content': 'Þegar þú ert kominn með “Client ID” og “Client Secret” frá Relesys, bætir þú þeim við í formið hér fyrir ofan og smellir á “Vista”.',
  'integrations.relesys.settings.clientid.label': 'Client ID',
  'integrations.relesys.settings.clientsecret.label': 'Client Secret',
  'integrations.relesys.settings.smstext.label': 'SMS Texti',
  'integrations.relesys.settings.submit': 'Vista',
  'integrations.relesys.settings.save.success': 'App vistað',
  'integrations.relesys.settings.save.error': 'App ekki vistað, vinsamlegast hafðu samband við 50skills',

  // Slack
  'integrations.slack.settings.header.connected': 'Tengt',
  'integrations.slack.settings.header.notconnected': 'Ekki tengt',
  'integrations.slack.settings.info': 'Fáðu tilkynningar í rauntíma í Slack þegar lykilatburðir gerast í 50skills',
  'integrations.slack.settings.info.a': 'A) Býr til lokaða rás í Slack fyrir hvert starf sem þú stofnar og býður ráðningarteymi inn í það',
  'integrations.slack.settings.info.b': 'B) Tilkynningar í Slack þegar nýir umsækjendur sækja um',
  'integrations.slack.settings.info.c': 'C) Tilkynningar þegar umsagnir eru skrifaðar um umsækjendur',
  'integrations.slack.settings.info.d': 'D) Hægt að senda deilanlega slóð á starfsmenn sem þau geta deilt með tilvonandi umsækjendum. Slóðin er reykjanleg uppá mögulega umbunun til starfsmanna',
  'integrations.slack.settings.buttons.connect': 'Tengjast',
  'integrations.slack.settings.buttons.reconnect': 'Endur-tengjast',
  'integrations.slack.settings.buttons.learnmore': 'Læra meira',

  // Signet
  'integrations.signet.button.submit': 'Senda',
  'integrations.signet.button.document.add': 'Bæta við skjali',
  'integrations.signet.templates.options.empty': 'Engin sniðmát til að senda',
  'integrations.signet.settings.header.connected': 'Tengt',
  'integrations.signet.settings.header.notconnected': 'Ekki tengt',
  'integrations.signet.settings.description': 'Hérna getið þið tengt Signet aðganginn hjá ykkar fyrirtæki við 50skills til að senda út rafræna samninga í gegnum kerfið.',
  'integrations.signet.settings.modal.reconnect': 'Endurtengja',
  'integrations.signet.settings.modal.connect': 'Tengja',
  'integrations.signet.settings.connect.modal.username.label': 'Notendanafn',
  'integrations.signet.settings.connect.modal.password.label': 'Lykilorð',
  'integrations.signet.settings.connect.modal.certificatepassword.label': 'Lykilorð skírteinis',
  'integrations.signet.settings.connect.modal.certificate.label': 'Skírteini',
  'integrations.signet.settings.connect.modal.header': 'Tengja Signet',
  'integrations.signet.settings.connect.modal.description': 'Setjið gögnin fyrir fyrirtækið í dálkana hér fyrir neðan til að tengjast. Ef þú ert óviss um hvaða gögn þú átt að setja inn hafðu þá samband við Signet tengiliðinn þinn.',
  'integrations.signet.settings.connect.modal.connect': 'Tengja',
  'integrations.signet.settings.connect.modal.cancel': 'Hætta við',
  'integrations.signet.settings.connect.modal.saved': 'Gögn vistuð',
  'integrations.signet.settings.connect.modal.error': 'Ekki tókst að vista, ertu viss um að gögnin séu rétt?',
  'integrations.signet.settings.cosigners.description': 'Tengingu við Signet er náð! Til þess að senda út samninga þá þarf að velja undirritanda fyrir hönd fyrirtækisins. Hér fyrir neðan getur þú stjórnað hvaða aðilar geta skrifað undir fyrir hönd þíns fyrirtækis. Þessa aðila er þá hægt að velja úr lista áður en samningur er sendur út til nýs starfsmanns.',
  'integrations.signet.settings.cosigners': 'Undirritendur',
  'integrations.signet.settings.cosigners.add': 'Bæta við',
  'integrations.signet.settings.cosigners.none': 'Engum undirritendum bætt við',
  'integrations.signet.settings.cosigners.edit': 'Breyta',
  'integrations.signet.settings.cosigners.delete': 'Eyða',
  'integrations.signet.settings.cosigners.remove.success': 'Undirritanda eytt',
  'integrations.signet.settings.cosigners.modal.header': 'Bæta við undirritanda',
  'integrations.signet.settings.cosigners.modal.edit.header': 'Breyta undirritanda',
  'integrations.signet.settings.cosigners.modal.name.label': 'Nafn',
  'integrations.signet.settings.cosigners.modal.email.label': 'Netfang',
  'integrations.signet.settings.cosigners.modal.ssn.label': 'Kennitala',
  'integrations.signet.settings.cosigners.modal.cancel': 'Hætta við',
  'integrations.signet.settings.cosigners.modal.submit': 'Bæta við',
  'integrations.signet.settings.cosigners.modal.save': 'Vista',
  'integrations.signet.settings.cosigners.modal.error': 'Ekki tókst að vista, ertu viss um að gögnin séu rétt?',
  'integrations.signet.settings.cosigners.add.success': 'Undirritanda bætt við',
  'integrations.signet.settings.cosigners.edit.success': 'Undirritandi vistaður',
  'integrations.signet.settings.credentials.expired': 'Skilríkin þín eru útrunnin, vinsamlegast tengið aftur til að endurvirkja þessa samþættingu aftur.',

  // Taktikal
  'integrations.taktikal.button.submit': 'Senda',
  'integrations.taktikal.button.document.add': 'Bæta við skjali',
  'integrations.taktikal.settings.header.connected': 'Tengt',
  'integrations.taktikal.settings.header.notconnected': 'Ekki tengt',
  'integrations.taktikal.settings.description': 'Hérna getið þið tengt Taktikal aðganginn hjá ykkar fyrirtæki við 50skills til að senda út rafræna samninga í gegnum kerfið.',
  'integrations.taktikal.settings.modal.connect': 'Tengja',
  'integrations.taktikal.settings.connect.modal.header': 'Tengja Taktikal',
  'integrations.taktikal.settings.connect.modal.description': 'Hérna getið þið tengt Taktikal aðganginn hjá ykkar fyrirtæki við 50skills til að senda út rafræna samninga í gegnum kerfið.',
  'integrations.taktikal.settings.connect.modal.flowkey.label': 'Flow key',
  'integrations.taktikal.settings.connect.modal.apikey.label': 'Api key',
  'integrations.taktikal.settings.connect.modal.companykey.label': 'Company key',
  'integrations.taktikal.settings.connect.modal.connect': 'Tengja',
  'integrations.taktikal.settings.connect.modal.cancel': 'Hætta við',
  'integrations.taktikal.settings.connect.modal.saved': 'Lyklar vistaðir',
  'integrations.taktikal.settings.connect.modal.error': 'Ekki tókst að vista, ertu viss um að lyklarnir séu réttir?',
  'integrations.taktikal.settings.cosigners.description': 'Tengingu við Taktikal er náð! Til þess að senda út samninga þá þarf að velja undirritanda fyrir hönd fyrirtækisins. Hér fyrir neðan getur þú stjórnað hvaða aðilar geta skrifað undir fyrir hönd þíns fyrirtækis. Þessir aðila er þá hægt að velja úr lista áður en samningur er sendur út til nýs starfsmanns.',
  'integrations.taktikal.settings.cosigners': 'Undirritendur',
  'integrations.taktikal.settings.cosigners.add': 'Bæta við',
  'integrations.taktikal.settings.cosigners.none': 'Engum undirritendum bætt við',
  'integrations.taktikal.settings.cosigners.reconnect': 'Endurtengja',
  'integrations.taktikal.settings.cosigners.modal.header': 'Bæta við undirritanda',
  'integrations.taktikal.settings.cosigners.modal.edit.header': 'Breyta undirritanda',
  'integrations.taktikal.settings.cosigners.modal.name.label': 'Nafn',
  'integrations.taktikal.settings.cosigners.modal.email.label': 'Netfang',
  'integrations.taktikal.settings.cosigners.modal.ssn.label': 'Kennitala',
  'integrations.taktikal.settings.cosigners.modal.phone.label': 'Símanúmer', 
  'integrations.taktikal.settings.cosigners.modal.cancel': 'Hætta við',
  'integrations.taktikal.settings.cosigners.modal.submit': 'Bæta við',
  'integrations.taktikal.settings.cosigners.modal.save': 'Vista',
  'integrations.taktikal.settings.cosigners.modal.error': 'Ekki tókst að vista, ertu viss um að gögnin séu rétt?',
  'integrations.taktikal.settings.cosigners.add.success': 'Undirritanda bætt við',
  'integrations.taktikal.settings.cosigners.edit.success': 'Undirritandi vistaður',
  'integrations.taktikal.settings.cosigners.remove.success': 'Undirritanda eytt',
  'integrations.taktikal.settings.cosigners.delete': 'Eyða',
  'integrations.taktikal.settings.cosigners.edit': 'Breyta',
  'integrations.taktikal.signaturelocation.label': 'Staðsetning undirskriftar',
  'integrations.taktikal.signaturelocation.topfirstpage': 'Efst á fyrstu blaðsíðu',
  'integrations.taktikal.signaturelocation.bottomlastpage': 'Neðst á seinustu blaðsíðu',
  'integrations.taktikal.signaturelocation.success': 'Staðsetning undirskriftar breytt',
  'integrations.taktikal.signaturelocation.error': 'Ekki tókst að vista staðsetningu undirskriftar',


  // Siminn Pay
  'application.onboarding.integration.siminnpay.sendinvite': 'Senda boð',

  // Teachable
  'application.onboarding.integration.teachable.sendinvite': 'Senda boð',

  // Eloomi
  'application.onboarding.integration.eloomi.submit': 'Stofna notanda',

  // Hireflix
  'integrations.hireflix.job.app.form.description': 'Tengdu Hireflix stöðu við þetta starf',
  'integrations.hireflix.job.app.form.position.label': 'Staða',
  'integrations.hireflix.job.app.form.save': 'Vista',
  'integrations.hireflix.job.app.info.position.label': 'Staða',
  'integrations.hireflix.job.app.info.notifications.label': 'Tilkynningar',
  'integrations.hireflix.job.app.info.notifications.email': 'Tölvupóstur',
  'integrations.hireflix.job.app.info.notifications.sms': 'SMS',
  'integrations.hireflix.job.app.info.notifications.whatsapp': 'WhatsApp',
  'integrations.hireflix.job.app.info.notifications.type.immediately': 'Sent um leið',
  'integrations.hireflix.job.app.info.notifications.type.afterhours': 'Eftir {0} klst',
  'integrations.hireflix.job.app.info.sent.label': 'Viðtöl send',
  'integrations.hireflix.job.app.info.completed.label': 'Viðtölum lokið',
  'integrations.hireflix.job.app.info.remove.label': 'Aftengja',
  'integrations.hireflix.job.app.nopositions': 'Engar stöður lausar í Hireflix. Vinsamlegast bættu við stöðu þar og komdu svo aftur hingað ⚡️',
  'integrations.hireflix.application.noapps': 'Engin forrit uppsett',
  'integrations.hireflix.application.linkposition': 'Tengja stöðu',
  'integrations.hireflix.application.jobnotlinked': 'Engin staða tengd við þetta starf',
  'integrations.hireflix.application.sendinterview': 'Senda viðtal',
  'integrations.hireflix.application.interviewnotsent': 'Ekkert viðtal sent',
  'integrations.hireflix.application.sentby.label': 'Sent af',
  'integrations.hireflix.application.status.label': 'Staða',
  'integrations.hireflix.application.status.invited': 'Boðið',
  'integrations.hireflix.application.status.completed': 'Lokið',
  'integrations.hireflix.application.status.sent': 'Viðtal sent',
  'integrations.hireflix.application.status.toevaluate': 'To evaluate',
  'integrations.hireflix.application.status.error': 'Ekki tókst að færa umsækjanda um stöðu',
  'integrations.hireflix.application.status.preselected': 'Pre-selected',
  'integrations.hireflix.application.status.discarded': 'Discarded',
  'integrations.hireflix.application.delete.confirm': 'Ertu viss um að þú viljir eyða viðtalinu? Því verður einnig eytt í Hireflix',
  'integrations.hireflix.application.delete.success': 'Viðtali eytt',
  'integrations.hireflix.application.delete.error': 'Ekki tókst að eyða viðtali',
  'integrations.hireflix.application.ratings.received': 'Einkunnir gefnar • {0}',
  'integrations.hireflix.application.ratings.viewall': 'Skoða einkunnir',
  'integrations.hireflix.application.rating.overall': 'Samanlögð einkunn',
  'integrations.hireflix.application.rating.strongno': 'Sterkt nei • 0',
  'integrations.hireflix.application.rating.no': 'Nei • 2.5',
  'integrations.hireflix.application.rating.average': 'Meðal • 5',
  'integrations.hireflix.application.rating.yes': 'Já • 7.5',
  'integrations.hireflix.application.rating.strongyes': 'Sterkt já • 10',
  'integrations.hireflix.application.question.rating.error': 'Ekki tókst að gefa einkunn',
  'integrations.hireflix.application.modal.header': 'Senda Hireflix viðtal',
  'integrations.hireflix.application.modal.position.label': 'Staða',
  'integrations.hireflix.application.modal.notifications.label': 'Tilkynningar',
  'integrations.hireflix.application.modal.submit': 'Senda viðtal',
  'integrations.hireflix.application.modals.reviews.header': 'Einkunnir',
  'integrations.hireflix.application.no.answer.found': 'Ekkert vídeó viðtal fannst',
  'integrations.hireflix.errors.invalidapikey': 'API Key er ekki réttur. Vinsamlegast athugið stillingarsíðuna hjá Hireflix',
  'integrations.hireflix.errors.candidatealreadyexists': 'Umsækjandi með þetta netfang er nnú þegar til á þessari stöðu',
  'integrations.hireflix.errors.expiredaccount': 'Hireflix aðgangurinn þinn er runnin út',
  'integrations.hireflix.settings.description': 'Velkomin/n, hér seturðu API key sem þú finnur í Hireflix. Til að sækja API key, þá ferðu í Your account -> API Keys og afritar API Key í reitinn hér fyrir neðan.',
  'integrations.hireflix.settings.apikey.label': 'API Key',
  'integrations.hireflix.settings.submit.label': 'Vista',
  'integrations.hireflix.settings.save.success': 'Stillingar vistaðar',
  'integrations.hireflix.filters.title': 'Hireflix',
  'integrations.hireflix.filters.rating': 'Einkunnir',
  'integrations.hireflix.filters.status': 'Staða',
  'integrations.hireflix.filters.status.sent': 'Viðtal sent',
  'integrations.hireflix.filters.status.completed': 'To evaluate',
  'integrations.hireflix.filters.status.finalist': 'Pre-selected',
  'integrations.hireflix.filters.status.archived': 'Discarded',
  'integrations.hireflix.filters.date_sent': 'Dagsetning',
  'integrations.hireflix.bulk.invite': 'Senda viðtöl',
  'integrations.hireflix.bulk.modal.send.header': 'Senda viðtöl á umsækjendur',
  'integrations.hireflix.bulk.modal.sent.header': 'Sendi viðtöl',
  'integrations.hireflix.bulk.modal.sent.text': 'Verið er að framkvæma aðgerðina. Athugið að þetta gæti tekið nokkrar mínútur',
  'integrations.hireflix.bulk.modal.send.error': 'Eitthvað fór úrskeiðis, vinsamlegast hafðu samband við 50skills',

  // H3Core
  'integrations.h3core.settings.description': 'Velkomin, hér seturðu inn upplýsingar um H3Core þjónustuna. Ef þú ert ekki með þessar upplýsingar, hafðu samband við þinn tengilið hjá Advania. Þegar stillingarnar hafa verið vistaðar, þá geturðu haft samband við 50skills.',
  'integrations.h3core.settings.url.label': 'Base URL',
  'integrations.h3core.settings.companyname.label': 'Company Name',
  'integrations.h3core.settings.username.label': 'Username',
  'integrations.h3core.settings.password.label': 'Password',
  'integrations.h3core.settings.submit.label': 'Staðfesta',
  'integrations.h3core.settings.save.success': 'Stillingar vistaðar',
  'integrations.h3core.errors.sslcertificateerror': 'SSL Certificate villa. Líklegast ástæða: Skírteini ekki rétt stillt',
  'integrations.h3core.errors.noconnection': 'Tengingu ekki náð. Líklegasta ástæða: Ekki búið að opna fyrir IP tölur',
  'integrations.h3core.errors.unknownerror': 'Óþekkt villa. Vinsamlegast hafið samband við Advania',
  'integrations.h3core.errors.authfailed': 'Auðkenningar villa. Eru aðgangs upplýsingarnar réttar?',
  'integrations.h3core.errors.notnullvalue': 'Villa frá H3Core. Líklegasta ástæða: Aannað hvort er fyrirtækjanafnið ekki til eða notandinn hefur ekki aðgang að því',
  'integrations.h3core.errors.notfound': 'URL ekki fundið. Ertu viss um að það sé rétt?',
  'integrations.h3core.errors.emptyresponse': 'Tómt svar frá H3Core. Vinsmalegast hafið samband við Advania',
  'integrations.h3core.bulk.edit': 'Breyta H3 gildum',
  'integrations.h3core.bulk.create': 'Stofna í H3',

  // Journeys
  'integrations.journeys.bulk.create': 'Bæta við í Journey',
  'integrations.journeys.stage.addTrigger': 'Bæta við sjálfvirkri ræsingu Journey-ferlis fyrir dálk',

  // Timon
  'integrations.timon.settings.connected': 'Tengt',
  'integrations.timon.settings.description': 'Velkomin, Hér seturðu inn upplýsingar um Tímon vefþjónustuna. Ef þú ert ekki með þessar upplýsingar, Hafðu samband við þinn tengilið hjá Trackwell. Þegar stillingarnar hafa verið vistaðar, ættirðu að geta byrjað notað tenginguna',
  'integrations.timon.settings.url.label': 'API vefslóð',
  'integrations.timon.settings.username.label': 'Notendanafn',
  'integrations.timon.settings.password.label': 'Lykilorð',
  'integrations.timon.settings.submit.label': 'Staðfesta',
  'integrations.timon.settings.save.success': 'Stillingar vistaðar',

  // MyTimePlan
  'integrations.mytimeplan.settings.connected': 'Tengt',
  'integrations.mytimeplan.settings.description': 'Velkomin, Hér seturðu inn upplýsingar um MyTimePlan vefþjónustuna. Ef þú ert ekki með þessar upplýsingar, Hafðu samband við þinn tengilið hjá MyTimePlan. Þegar stillingarnar hafa verið vistaðar, ættirðu að geta byrjað notað tenginguna',
  'integrations.mytimeplan.settings.url.label': 'API vefslóð',
  'integrations.mytimeplan.settings.username.label': 'Notendanafn',
  'integrations.mytimeplan.settings.password.label': 'Lykilorð',
  'integrations.mytimeplan.settings.submit.label': 'Staðfesta',
  'integrations.mytimeplan.settings.save.success': 'Stillingar vistaðar',

  // Dokobit
  'integrations.dokobit.settings.description': 'Hérna getið þið tengt Dokobit aðganginn hjá ykkar fyrirtæki við 50skills til að senda út rafræna samninga í gegnum kerfið. Til þess að tengjast þá þarf að setja inn API token í reitinn hér fyrir neðan sem þú getur nálgast með því að hafa samband við ykkar tengilið hjá Dokobit.',
  'integrations.dokobit.settings.token.label': 'Token',
  'integrations.dokobit.settings.token.submit': 'Vista',
  'integrations.dokobit.settings.token.saved': 'Token vistað',
  'integrations.dokobit.settings.token.error': 'Ekki tókst að vista, ertu viss um að Token sé rétt?',
  'integrations.dokobit.settings.cosigners.description': 'Tengingu við Dokobit er náð! Til þess að senda út samninga þá þarf að velja undirritanda fyrir hönd fyrirtækisins. Hér fyrir neðan getur þú stjórnað hvaða aðilar geta skrifað undir fyrir hönd þíns fyrirtækis. Þessir aðila er þá hægt að velja úr lista áður en samningur er sendur út til nýs starfsmanns',
  'integrations.dokobit.settings.cosigners': 'Undirritendur',
  'integrations.dokobit.settings.cosigners.none.header': 'Engir undirritendur',
  'integrations.dokobit.settings.cosigners.none.content': 'Bættu við unirritendum með því að smella á + hér að ofan',
  'integrations.dokobit.settings.cosigners.add': 'Bæta við',
  'integrations.dokobit.settings.cosigners.edit': 'Breyta',
  'integrations.dokobit.settings.cosigners.delete': 'Eyða',
  'integrations.dokobit.settings.cosigners.modal.header': 'Bæta við undirritanda',
  'integrations.dokobit.settings.cosigners.modal.edit.header': 'Breyta undirritanda',
  'integrations.dokobit.settings.cosigners.modal.name.label': 'Nafn',
  'integrations.dokobit.settings.cosigners.modal.email.label': 'Netfang',
  'integrations.dokobit.settings.cosigners.modal.ssn.label': 'Kennitala',
  'integrations.dokobit.settings.cosigners.modal.phone.label': 'Símanúmer',
  'integrations.dokobit.settings.cosigners.modal.cancel': 'Hætta við',
  'integrations.dokobit.settings.cosigners.modal.submit': 'Bæta við',
  'integrations.dokobit.settings.cosigners.modal.save': 'Vista',
  'integrations.dokobit.settings.cosigners.add.success': 'Undirritanda bætt við',
  'integrations.dokobit.settings.cosigners.edit.success': 'Undirritandi vistaður',
  'integrations.dokobit.settings.cosigners.remove.success': 'Undirritanda eytt',
  'integrations.dokobit.onboarding.form.template.none': 'Engin sniðmát fáanleg',
  'integrations.dokobit.onboarding.form.template.label': 'Sniðmát',
  'integrations.dokobit.onboarding.form.template.error': 'Villa við að sækja sniðmát',
  'integrations.dokobit.onboarding.form.document.cancel': 'Hætta við',
  'integrations.dokobit.onboarding.form.document.add': 'Bæta við skjali',
  'integrations.dokobit.onboarding.form.success': 'Samningur sendur til undirritunar',
  'integrations.dokobit.onboarding.form.saved': 'Upplýsingar vistaðar',
  'integrations.dokobit.onboarding.form.deleted': 'Upplýsingum eytt',
  'integrations.dokobit.onboarding.form.cosigners.placeholder': 'Undirritendur',
  'integrations.dokobit.onboarding.form.cosigners.label': 'Velja undirritendur',
  'integrations.dokobit.onboarding.form.cosigners.nooptions': 'Ekki fleiri undirritendur',
  'integrations.dokobit.onboarding.form.submit': 'Senda',
  'integrations.dokobit.onboarding.form.save': 'Vista',
  'integrations.dokobit.onboarding.form.save.saved': 'Vistað',
  'integrations.dokobit.onboarding.form.errors.title': 'Dokobit returned the following errors:',
  'integrations.dokobit.onboarding.contract.delete.notification': 'Skjali eytt',
  'integrations.dokobit.onboarding.contract.document.label': 'Skjal',
  'integrations.dokobit.onboarding.contract.datesent.label': 'Dagsetning sendingar',
  'integrations.dokobit.onboarding.contract.sentby.label': 'Sent af',
  'integrations.dokobit.onboarding.contract.signer.label': 'Undirritari • {0}',
  'integrations.dokobit.onboarding.contract.signer.signed': 'Undirritað',
  'integrations.dokobit.onboarding.contract.signer.pending': 'Beðið eftir svari',
  'integrations.dokobit.onboarding.contract.signer.declined': 'Hafnað',
  'integrations.dokobit.onboarding.info.remove': 'Fjarlægja skjal',
  'integrations.dokobit.onboarding.info.remove.description': 'Ertu viss um að þú viljir fjarlægja þetta skjal?',
  'integrations.dokobit.onboarding.info.delete': 'Eyða skjali',
  'integrations.dokobit.onboarding.info.delete.description': 'Ertu viss um að þú viljir eyða þessu skjali? Það hefur þegar verið sent og það verður fjarlægt fyrir alla undirritara',
  'integrations.dokobit.signaturelocation.label': 'Staðsetning undirskriftar',
  'integrations.dokobit.signaturelocation.topfirstpage': 'Efst á fyrstu blaðsíðu',
  'integrations.dokobit.signaturelocation.bottomfirstpage': 'Neðst á fyrstu blaðsíðu',
  'integrations.dokobit.signaturelocation.toplastpage': 'Efst á seinustu blaðsíðu',
  'integrations.dokobit.signaturelocation.bottomlastpage': 'Neðst á seinustu blaðsíðu',
  'integrations.dokobit.signaturelocation.success': 'Staðsetning undirskriftar breytt',
  'integrations.dokobit.signaturelocation.error': 'Ekki tókst að vista staðsetningu undirskriftar',

  'jobboards.tvinna.title.status': 'Starfshlutfall',
  'jobboards.tvinna.title.extra': 'Upplýsingar fyrir umsækjendur',
  'jobboards.tvinna.info': 'Upplýsingar um Tvinna',
  'jobboards.hi.info': 'Upplýsingar um Tengslatorg HÍ',
  'jobboards.jobdotis.info': 'Upplýsingar um Job.is',

  'jobboards.post.heading': 'Auglýsing á {0}',
  'jobboards.post.language': 'Tungumál',
  'jobboards.post.back': 'Til baka',
  'jobboards.post.go': 'Staðfesta póst',
  'jobboards.post.example': 'Hvernig lítur auglýsingin út?',
  'jobboards.select.heading': 'Veldu starfatorg til auglýsingar',
  'jobboards.select.cancel': 'Hætta við',
  'jobboards.select.go': 'Áfram',
  'jobboards.list.view': 'Skoða',

  'jobboards.table.jobboard': 'Starfatorg',
  'jobboards.table.price': 'Verð',
  'jobboards.table.link': 'Hlekkur',
  'jobboards.table.user': 'Notandi',
  'jobboards.table.options': 'Aðgerðir',
  'jobboards.table.posted': 'Dagsetning',
  'jobboards.postlist.header': 'Auglýsingar á starfatorgum',
  'jobboards.postlist.text': 'Fleiri augu vita af starfinu þínu með auglýsingum á starfatorgum.',
  'jobboards.settings.connected': 'Tengd starfatorg',
  'jobboards.settings.available': 'Ótengd starfatorg',
  'jobboards.settings.noc': 'Engin starfatorg tengd',
  'jobboards.settings.nocText': 'Tengdu starfatorg og þú getur búið til auglýsingar fyrir hvert starf hér í 50skills.',
  'jobboards.settings.btn.disconnect': 'Aftengja',
  'jobboards.settings.btn.connect': 'Tengja',
  'jobboards.connect.success': 'Starfatorg tengt.',
  'jobboards.connect.error': 'Ekki tókst að tengja starfatorg. Vinsamlega hafðu samband við 50skills.',
  'jobboards.disconnect.success': 'Starfatorg aftengt.',
  'jobboards.disconnect.error': 'Ekki tókst að aftengja starfatorg {0}. Vinsamlega hafðu samband við 50skills.',
  'jobboards.create': 'Senda á starfatorg',
  'jobboards.submit.success': 'Auglýsing fyrir starf {0} hefur verið búin til á starfatorgi {1}.',
  'jobboards.submit.error': 'Ekki tókst að búa til auglýsingu fyrir starf  {0} á starfatorgi {1}. Vinsamlega hafðu samband við 50skills.',
  'jobboards.emptyposts.heading': 'Engar auglýsingar á starfatorgum',
  'jobboards.emptyposts.text': 'Viltu auka sýnileikann? Tengdu uppáhalds starfatorgin þín og auglýstu beint frá 50skills.',
  'jobboards.emptyboards.heading': 'Engin starfatorg tengd',
  'jobboards.emptyboards.text': 'Í fyrirtækjastillingum þarf að tengja þau starfatorg sem á að nota til auglýsinga.',
  'jobboards.emptyboards.btn': 'Fara í stillingar',
  'jobboards.list.menu.remove': 'Eyða auglýsingu',
  'jobboards.removepost.success': 'Auglýsing fjarlægð af starfatorgi.',
  'jobboards.removepost.error': 'Ekki tókst að fjarlægja auglýsingu af starfatorgi. Vinsamlega hafðu samband við 50skille.',

  'pipeline.tooltip.rating': '1 einkunnagjöf á umsókn.',
  'pipeline.tooltip.ratings': '{0} einkunnagjafir á umsókn.',
  'pipeline.tooltip.note': '1 umsögn á umsókn.',
  'pipeline.tooltip.notes': '{0} umsagnir á umsókn.',
  'pipeline.tooltip.file': '1 skrá viðhengd á umsókn.',
  'pipeline.tooltip.files': '{0} skrár viðhengar á umsókn.',
  'pipeline.tooltip.message': '1 skilaboð á umsókn.',
  'pipeline.tooltip.messages': '{0} skilaboð á umsókn.',
  'pipeline.tooltip.assignee': 'Umsókn úthlutað á {0}.',
  'pipeline.tooltip.tasklist': '1 óklárað verk á umsókn.',
  'pipeline.tooltip.tasklists': '{0} ókláruð verk á umsókn.',

  'company.apps.filters.header': 'Nýir starfsmenn',
  'company.apps.filters.sub_header': 'Sía',
  'company.apps.filters.search.placeholder': 'Leita eftir nafni',
  'company.apps.filters.all': 'Allt',

  'ssnregistry.gender.1': 'Karlkyn',
  'ssnregistry.gender.2': 'Kvenkyn',
  'ssnregistry.gender.3': 'Karlkyn',
  'ssnregistry.gender.4': 'Kvenkyn',
  'ssnregistry.gender.7': 'Kynsegin/annað',
  'ssnregistry.gender.8': 'Kynsegin/annað',

  'maintenance.header': 'Viðhald',
  'maintenance.message': '50skills er í skipulögðu viðhaldi eins og er. Við snúum aftur betri, hraðari og sterkari en nokkru sinni fyrr eftir skamma stund. Við biðjumst innilega velvirðingar á óþægindunum.',
  'maintenance.info': 'Viðhaldið á einungis við um fyrirtækjaviðmótið (admin) og kerfið mun áfram taka við umsóknum meðan viðhald stendur yfir.',
  'maintenance.thanks': 'Þakka þér fyrir þolinmæðina.',
  'maintenance.button': 'Samband við þjónustuver',

  'applicants_columns.review.sort.asc': 'Raða Lægst → Hæst',
  'applicants_columns.review.sort.desc': 'Raða Hæst → Lægst'
};
